(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3533],{

/***/ 61620:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Extension"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Extension"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":53}}');
    doc.loc.source = JSON.parse('{"body":"fragment Extension on Extension {\\n  type\\n  service\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 67394:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Batch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Batch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualScrap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":144}}');
    doc.loc.source = JSON.parse('{"body":"fragment Batch on Batch {\\n  batchId\\n  batchNumber\\n  state\\n  amount\\n  manualScrap\\n  plannedStart\\n  actualStart\\n  actualStop\\n  comment\\n  lineId\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 96352:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Packaging"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Packaging"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagingNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":101}}');
    doc.loc.source = JSON.parse('{"body":"fragment Packaging on Packaging {\\n  packagingId\\n  lineId\\n  name\\n  packagingNumber\\n  unit\\n  comment\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 50619:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedLineSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedAverageSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":181}}');
    doc.loc.source = JSON.parse('{"body":"fragment Product on Product {\\n  productId\\n  name\\n  itemNumber\\n  lineId\\n  validatedLineSpeed\\n  expectedAverageSpeed\\n  dataMultiplier\\n  comment\\n  parameters {\\n    key\\n    value\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 79696:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SensorConfigEnums"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"units"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"Unit","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"units"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"analogInputRanges"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"AnalogInputRange","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"analogInputRanges"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sensorTypes"},"name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"SensorType","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sensorTypes"},"name":{"kind":"Name","value":"enumValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":379}}');
    doc.loc.source = JSON.parse('{"body":"fragment SensorConfigEnums on Query {\\n  units: __type(name: \\"Unit\\") {\\n    units: enumValues {\\n      name\\n      description\\n    }\\n  }\\n  analogInputRanges: __type(name: \\"AnalogInputRange\\") {\\n    analogInputRanges: enumValues {\\n      name\\n      description\\n    }\\n  }\\n  sensorTypes: __type(name: \\"SensorType\\") {\\n    sensorTypes: enumValues {\\n      name\\n      description\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 10899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Stops"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stop"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ongoing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMicroStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registeredTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countermeasure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countermeasureInitials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"standalone"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"excludeProduction"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previousBatch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextBatch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"target"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stopCause"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopCause"},"directives":[]}]}}]}}],"loc":{"start":0,"end":485}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-cause.gql\'\\n\\nfragment Stops on Stop {\\n  _id # There used to be bug with overlapping standalone stops (see git history), but probably not relevant anymore\\n  __typename\\n  duration\\n  ongoing\\n  isMicroStop\\n  comment\\n  initials\\n  registeredTime\\n  countermeasure\\n  countermeasureInitials\\n  standalone {\\n    excludeProduction\\n  }\\n  target {\\n    previousBatch\\n    nextBatch\\n    target\\n  }\\n  timeRange {\\n    to\\n    from\\n  }\\n  stopCause {\\n    ...StopCause\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(16634).definitions)));


      module.exports = doc;
    


/***/ }),

/***/ 65868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"lineCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineNodeInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineEdgeInput"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLineWithTopology"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"nodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}}},{"kind":"Argument","name":{"kind":"Name","value":"edges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edges"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Node"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSensor"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":568}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/line/node-with-sensor.gql\'\\n\\nmutation lineCreate(\\n  $groupId: ID!\\n  $name: String!\\n  $description: String\\n  $nodes: [LineNodeInput!]!\\n  $edges: [LineEdgeInput!]! # $bottleneckId: ID! # $sensorConfig: SensorConfigInput!\\n) {\\n  createLineWithTopology(groupId: $groupId, name: $name, description: $description, nodes: $nodes, edges: $edges) {\\n    id\\n    name\\n    description\\n    nodes {\\n      ...Node\\n      sensor {\\n        ...NodeSensor\\n      }\\n    }\\n    edges {\\n      from\\n      to\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(49478).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineCreate = oneQuery(doc, "lineCreate");
        


/***/ }),

/***/ 95540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"andonListUnresolvedCallsForLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"available"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"extensions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Extension"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resolved"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urgency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"make"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"take"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":497}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/andon-legacy/extension.gql\'\\n\\nquery andonListUnresolvedCallsForLine($lineId: ID!) {\\n  andon {\\n    companyId\\n    supportTypes(available: true) {\\n      id\\n      name\\n    }\\n    extensions {\\n      ...Extension\\n    }\\n    tags(lineId: $lineId) {\\n      id\\n      value\\n    }\\n    calls(resolved: false, lineId: $lineId) {\\n      id\\n      urgency\\n      action {\\n        make {\\n          time\\n          details\\n        }\\n        take {\\n          time\\n        }\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(61620).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonListUnresolvedCallsForLine = oneQuery(doc, "andonListUnresolvedCallsForLine");
        


/***/ }),

/***/ 92126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lineOverviewWithKPI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"points"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showStops"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showOee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showWeeklyProgress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showDailyProgress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasMaintenanceModule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTimeInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pastWeek"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pastDay"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showWeeklyProgress"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weeklyTargets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainSensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"lineOverviewWithKPI","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"samples"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"points"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"batches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Batch"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packaging"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Packaging"},"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"oee"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showOee"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tcu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalEquipmentTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mannedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productionTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuedOperatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speedLoss"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scrapLoss"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stops"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showStops"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Stops"},"directives":[]}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pastWeekTime"},"name":{"kind":"Name","value":"time"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pastWeek"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showWeeklyProgress"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pastDayTime"},"name":{"kind":"Name","value":"time"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pastDay"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showDailyProgress"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maintenanceWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasMaintenanceModule"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfigEnums"},"directives":[]}]}}],"loc":{"start":0,"end":2725}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/sensor-config-enums.gql\'\\n#import \'@/graphql/fragments/batch.gql\'\\n#import \'@/graphql/fragments/product.gql\'\\n#import \'@/graphql/fragments/packaging.gql\'\\n#import \'@/graphql/fragments/stops.gql\'\\n\\nquery lineOverviewWithKPI(\\n  $lineId: ID!\\n  $time: [Time!]!\\n  $points: Int!\\n  $showStops: Boolean!\\n  $showOee: Boolean!\\n  $showWeeklyProgress: Boolean!\\n  $showDailyProgress: Boolean!\\n  $hasMaintenanceModule: Boolean!\\n  $validIn: ScheduleTimeInput!\\n  $pastWeek: [Time!]!\\n  $pastDay: [Time!]!\\n) {\\n  line(lineId: $lineId) {\\n    id\\n    name\\n    description\\n\\n    schedule(validIn: $validIn) @include(if: $showWeeklyProgress) {\\n      weeklyTargets {\\n        produced\\n      }\\n    }\\n\\n    mainSensor {\\n      _id\\n      peripheralId\\n      name\\n      config {\\n        ...SensorConfig\\n      }\\n      time(time: $time) @connection(key: \\"lineOverviewWithKPI\\") {\\n        timeRange {\\n          from\\n          to\\n        }\\n        samples(points: $points) {\\n          data {\\n            count\\n            accValue\\n            minValue\\n            maxValue\\n          }\\n          timeRange {\\n            from\\n            to\\n          }\\n        }\\n        batches {\\n          nextToken\\n          items {\\n            ...Batch\\n            stats {\\n              data {\\n                produced\\n              }\\n            }\\n            product {\\n              ...Product\\n              packaging {\\n                ...Packaging\\n              }\\n            }\\n          }\\n        }\\n        stats {\\n          data {\\n            lineStatus {\\n              status\\n              duration\\n              cause\\n            }\\n            oee @include(if: $showOee) {\\n              oee1\\n              oee2\\n              oee3\\n              tcu\\n              totalEquipmentTime\\n              mannedTime\\n              productionTime\\n              operatingTime\\n              valuedOperatingTime\\n              speedLoss\\n              scrapLoss\\n            }\\n          }\\n        }\\n        stops @include(if: $showStops) {\\n          ...Stops\\n        }\\n      }\\n    }\\n    pastWeekTime: time(time: $pastWeek) @include(if: $showWeeklyProgress) {\\n      _id\\n      timeRange {\\n        to\\n        from\\n      }\\n      stats {\\n        data {\\n          produced\\n        }\\n      }\\n    }\\n    pastDayTime: time(time: $pastDay) @include(if: $showDailyProgress) {\\n      _id\\n      timeRange {\\n        to\\n        from\\n      }\\n      stats {\\n        data {\\n          produced\\n        }\\n      }\\n    }\\n    nodes {\\n      sensor {\\n        _id\\n        maintenanceWorkOrders(first: 1) @include(if: $hasMaintenanceModule) {\\n          nodes {\\n            timestamp\\n          }\\n        }\\n      }\\n    }\\n  }\\n  ...SensorConfigEnums\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(79696).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(67394).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(50619).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(96352).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(10899).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineOverviewWithKPI = oneQuery(doc, "lineOverviewWithKPI");
        


/***/ }),

/***/ 16450:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"linesListSimple"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":111}}');
    doc.loc.source = JSON.parse('{"body":"query linesListSimple($companyId: ID) {\\n  lines(companyId: $companyId) {\\n    id\\n    name\\n    description\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.linesListSimple = oneQuery(doc, "linesListSimple");
        


/***/ }),

/***/ 18828:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sensorGroups"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":336}}');
    doc.loc.source = JSON.parse('{"body":"query sensorGroups {\\n  company {\\n    id\\n    groups {\\n      id\\n      name\\n      sensors {\\n        _id\\n        name\\n        description\\n        peripheralId\\n        peripheralType\\n        config {\\n          type\\n        }\\n        peripheralInformation {\\n          node {\\n            peripheralId\\n          }\\n        }\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.sensorGroups = oneQuery(doc, "sensorGroups");
        


/***/ }),

/***/ 19536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ overview_top_bar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(96741);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(35422);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(15015);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+base@5.0.0-alpha.125_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(51285);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(73469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(96620);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+system@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react@17.0.2/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(39481);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-select@3.2.0_react-dom@17.0.2_react@17.0.2/node_modules/react-select/creatable/dist/react-select.browser.esm.js + 18 modules
var react_select_browser_esm = __webpack_require__(63554);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./components/bars/search-bar.tsx


























var styles = function(theme) {
    return {
        root: {
            flex: 1
        },
        input: {
            display: "flex",
            padding: 0,
            height: theme.spacing(5)
        },
        valueContainer: {
            display: "flex",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
            overflow: "hidden"
        },
        chip: {
            margin: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(0.25))
        },
        chipFocused: {
            backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
        },
        noOptionsMessage: {
            padding: "".concat(theme.spacing(), "px ").concat(theme.spacing(2))
        },
        singleValue: {
            fontSize: 16
        },
        placeholder: {
            position: "absolute",
            left: 2,
            fontSize: 16
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(),
            left: 0,
            right: 0
        },
        divider: {
            height: theme.spacing(2)
        }
    };
};
function NoOptionsMessage(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.noOptionsMessage
    }, props.innerProps), {
        children: props.children
    }));
}
function inputComponent(_param) {
    var inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputRef"
    ]);
    // NOTE: Order is important, InputBase sets ref to null, thus we ensure it's
    // value by setting ref after the spread.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: inputRef
    }));
}
function Control(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        variant: "filled",
        fullWidth: true,
        InputProps: {
            inputComponent: inputComponent,
            inputProps: (0,_object_spread/* default */.Z)({
                className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.input,
                inputRef: props.innerRef,
                children: props.children
            }, props.innerProps)
        }
    }, props.selectProps.textFieldProps));
}
function Option(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            minWidth: 0,
            padding: "5px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: props.innerRef,
            selected: props.isFocused,
            component: "div",
            style: {
                fontWeight: props.isSelected ? 500 : 400,
                width: "100%"
            }
        }, props.innerProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: [
                    " ",
                    props.children,
                    " "
                ]
            })
        }))
    });
}
function Placeholder(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.placeholder
    }, props.innerProps), {
        children: props.children
    }));
}
function SingleValue(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.singleValue
    }, props.innerProps), {
        children: props.children
    }));
}
function ValueContainer(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.valueContainer,
        children: props.children
    });
}
function MultiValue(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        tabIndex: -1,
        label: props.children,
        className: (0,clsx_m["default"])((ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.chip, (0,_define_property/* default */.Z)({}, (ref1 = props.selectProps.classes) === null || ref1 === void 0 ? void 0 : ref1.chipFocused, props.isFocused)),
        onDelete: props.removeProps.onClick,
        deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, (0,_object_spread/* default */.Z)({}, props.removeProps))
    });
}
function Menu(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        square: true,
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.paper
    }, props.innerProps), {
        children: props.children
    }));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
};
var createOption = function(label) {
    return {
        label: label,
        value: {
            type: "string",
            value: label
        }
    };
};
var SearchBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SearchBar, _Component);
    var _super = (0,_create_super/* default */.Z)(SearchBar);
    function SearchBar() {
        (0,_class_call_check/* default */.Z)(this, SearchBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputValue: ""
        };
        _this.formatLabel = function(val) {
            return "".concat(_this.props.t([
                "shared:searchFor"
            ], {
                defaultValue: "Search for"
            }), ' "').concat(val, '"');
        };
        _this.createOption = function(inputValue) {
            return _this.props.handleChange((0,_to_consumable_array/* default */.Z)(_this.props.value).concat([
                createOption(inputValue)
            ]));
        };
        _this.handleChange = function(val) {
            _this.props.handleChange(Array.isArray(val) ? val : val ? [
                val
            ] : []);
        };
        return _this;
    }
    var _proto = SearchBar.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, value = _props.value, theme = _props.theme, suggestions = _props.suggestions, t = _props.t;
        var selectStyles = {
            input: function(base) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                    color: theme.palette.text.primary,
                    "& input": {
                        font: "inherit"
                    }
                });
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                style: {
                                    marginRight: theme.spacing(),
                                    backgroundColor: "#269AE0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            style: {
                                flexGrow: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                                classes: classes,
                                styles: selectStyles,
                                textFieldProps: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                createOptionPosition: "first",
                                formatCreateLabel: this.formatLabel,
                                options: suggestions,
                                components: components,
                                value: value,
                                onCreateOption: this.createOption,
                                onChange: this.handleChange,
                                placeholder: "".concat(t([
                                    "shared:typeToSearch"
                                ], {
                                    defaultValue: "Type to search"
                                }), "..."),
                                isMulti: true,
                                isClearable: true
                            })
                        })
                    ]
                })
            })
        });
    };
    return SearchBar;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var search_bar = (enhance(SearchBar));

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
;// CONCATENATED MODULE: ./components/bars/overview-top-bar.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            overflow: "visible",
            marginBottom: theme.spacing(),
            "@media print": {
                display: "none"
            }
        },
        content: {
            paddingBottom: theme.spacing(2)
        },
        divContainer: {
            display: "flex",
            width: "100%",
            flexWrap: "nowrap"
        },
        hideOnSMDown: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        hideOnMDup: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.up("md"), {
            display: "none"
        })
    };
});
var OverviewTopBar = function(param) {
    var suggestions = param.suggestions, search = param.search, children = param.children, totalCount = param.totalCount, page = param.page, pageSize = param.pageSize, handleSearchChange = param.handleSearchChange, handlePageChange = param.handlePageChange;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        elevation: 1,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: classes.content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.divContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar, {
                            suggestions: suggestions,
                            value: search,
                            handleChange: handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.hideOnSMDown,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                }),
                                children
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.hideOnMDup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        justifyContent: "space-between",
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var overview_top_bar = (OverviewTopBar);


/***/ }),

/***/ 4228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53236);
/* harmony import */ var _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65680);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);






var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        stickyBottom: {
            // Escape the grouped stacking context to avoid filter/opacity bleeding effects.
            zIndex: 1,
            bottom: theme.spacing(4),
            height: 68,
            marginBottom: theme.spacing(3),
            position: "sticky",
            width: 1,
            left: "100%"
        },
        bottomRight: {
            position: "absolute",
            bottom: 0,
            right: theme.spacing(3)
        }
    };
});
var StickyFab = function(param) {
    var children = param.children, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _title = param.title, title = _title === void 0 ? "" : _title, onClick = param.onClick, _Icon = param.Icon, Icon = _Icon === void 0 ? _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _Icon;
    var classes = useStyles().classes;
    var child = children && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
        className: classes.bottomRight
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        color: "primary",
        disabled: disabled,
        className: classes.bottomRight,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {})
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.stickyBottom,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            title: title,
            placement: "top-start",
            children: button
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyFab);


/***/ }),

/***/ 7907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24267);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5887);










var styles = function() {
    return {
        small: {
            height: "2em",
            width: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
};
var Box = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Box, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Box);
    function Box() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Box);
        return _super.apply(this, arguments);
    }
    var _proto = Box.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, className = _props.className, small = _props.small, backgroundColor = _props.backgroundColor, _cardContentClass = _props.cardContentClass, cardContentClass = _cardContentClass === void 0 ? "" : _cardContentClass;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            elevation: 1,
            className: className,
            style: {
                backgroundColor: backgroundColor ? backgroundColor : "#ffffff"
            },
            children: small ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.small,
                children: this.props.children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: cardContentClass,
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: this.props.children
            })
        });
    };
    return Box;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)(_hocs__WEBPACK_IMPORTED_MODULE_8__/* .withUtils */ .W, (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Box));


/***/ }),

/***/ 50524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16321);
/* harmony import */ var _mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71980);
/* harmony import */ var _mui_icons_material_SignalCellular1Bar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36277);
/* harmony import */ var _mui_icons_material_SignalCellular2Bar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78408);
/* harmony import */ var _mui_icons_material_SignalCellular3Bar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90313);
/* harmony import */ var _mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43333);
/* harmony import */ var _mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86256);
/* harmony import */ var _mui_icons_material_SignalWifi1Bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90117);
/* harmony import */ var _mui_icons_material_SignalWifi2Bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9561);
/* harmony import */ var _mui_icons_material_SignalWifi3Bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1025);
/* harmony import */ var _mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80331);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15015);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8942);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82672);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5887);



















var styles = function(theme) {
    return {
        avatarGreen: {
            backgroundColor: "#59b78cff"
        },
        avatarWhite: {
            backgroundColor: "#fff"
        },
        avatarRed: {
            backgroundColor: "#ff7068ff"
        },
        iconWhite: {
            color: "white"
        },
        iconBlack: {
            color: theme.palette.primary.main
        }
    };
};
var SignalAvatar = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)(), 1), t = ref[0];
    var classes = props.classes, conn = props.conn, isUnclaimed = props.isUnclaimed;
    var type = "wifi";
    var strength = 4;
    var helperText = "";
    if (conn && conn.type) {
        type = conn.type;
    }
    if (conn && conn.strength !== undefined && conn.strength !== null) {
        strength = conn.strength;
    }
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: classes.iconBlack
    });
    var colorClass = classes.avatarWhite;
    if (isUnclaimed) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: classes.iconBlack
        });
        helperText = t([
            "shared:deviceArchived"
        ], {
            defaultValue: "Device archived"
        });
    } else if (type === "wifi") {
        helperText = t([
            "shared:wifiSignalStrength"
        ], {
            defaultValue: "WiFi signal strength"
        });
        switch(strength){
            case 0:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 1:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi1Bar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 2:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi2Bar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 3:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi3Bar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 4:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
        }
    } else if (type === "cellular") {
        helperText = t([
            "shared:celularSignalStrength"
        ], {
            defaultValue: "Celular signal strength"
        });
        switch(strength){
            case 0:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: classes.iconWhite
                });
                colorClass = classes.avatarRed;
                break;
            case 1:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular1Bar__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 2:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular2Bar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 3:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular3Bar__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 4:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        title: helperText,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__["default"])(colorClass, "hideInPercy"),
            children: icon
        })
    });
// return (
// <Tooltip
//   title={
//     <p>
//       {`Connection type: ${type}`}
//       <br />
//       {`Signal strength: ${strength + 1}/5`}
//     </p>
//   }>
//   <Avatar className={colorClass}>{icon}</Avatar>
// </Tooltip>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles)(SignalAvatar));


/***/ }),

/***/ 92707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_RingVolume__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90370);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52875);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16438);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32624);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14517);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _components_card_box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7907);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5887);
/* harmony import */ var _lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43078);


















var styles = function(theme) {
    return {
        // TODO: Re-factor this, it's used in the Andon overview as well.
        "@keyframes pulseUrgencyCritical": {
            "0%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][800] */ .Z[800]
            },
            "50%": {
                color: "inherit"
            },
            "100%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][800] */ .Z[800]
            }
        },
        "@keyframes pulseUrgencyMedium": {
            "0%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"][600] */ .Z[600]
            },
            "50%": {
                color: "inherit"
            },
            "100%": {
                color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"][600] */ .Z[600]
            }
        },
        buttonUrgencyCritical: {
            animationName: "$pulseUrgencyCritical"
        },
        buttonUrgencyMedium: {
            animationName: "$pulseUrgencyMedium"
        },
        andonIndicator: {
            marginLeft: "1em",
            fontSize: "inherit",
            color: "inherit",
            animationIterationCount: "infinite",
            animationDuration: "3s"
        },
        cardContentClass: {
            padding: "0 !important",
            paddingBottom: "0px !important"
        }
    };
};
var LineStatus = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(LineStatus, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(LineStatus);
    function LineStatus() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, LineStatus);
        return _super.apply(this, arguments);
    }
    var _proto = LineStatus.prototype;
    _proto.render = function render() {
        var _props = this.props, className = _props.className, moreStyle = _props.moreStyle, _lineStatus = _props.lineStatus, statusText = _lineStatus.statusText, statusColor = _lineStatus.statusColor, lineDuration = _lineStatus.lineDuration, unresolvedCall = _lineStatus.unresolvedCall, small = _props.small, utils = _props.utils, sensorType = _props.sensorType, t = _props.t, theme = _props.theme, classes = _props.classes, _wide = _props.wide, wide = _wide === void 0 ? true : _wide;
        var stopText = statusText;
        if ((0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__/* .stopTypeNames */ .R)(t)[statusText]) {
            stopText = (0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_8__/* .stopTypeNames */ .R)(t)[statusText];
        }
        var showDuration = true;
        if (sensorType === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .SensorType.MEASUREMENT */ .dE.MEASUREMENT) {
            showDuration = false;
        }
        var hasNeverBeenOnline = false;
        var durationString = null;
        try {
            // If it has never been online since 2000-01-01, then it has literally never been online.
            var now = new Date().getTime();
            if (new Date(now - lineDuration) < new Date("2000-01-01")) {
                hasNeverBeenOnline = true;
            }
        } catch (_err) {}
        if (!hasNeverBeenOnline) {
            var lineDurationDays = lineDuration - lineDuration % (24 * 3600 * 1000);
            var lineDurationHours = lineDuration - lineDurationDays - lineDuration % (3600 * 1000);
            var lineDurationMinutes = lineDuration - lineDurationDays - lineDurationHours - lineDuration % (1000 * 60);
            var lineDurationSeconds = lineDuration - lineDurationDays - lineDurationHours - lineDurationMinutes - lineDuration % 1000;
            var lineDurationMiliseconds = lineDuration - lineDurationDays - lineDurationHours - lineDurationMinutes - lineDurationSeconds - lineDuration;
            if (lineDuration < 1000) {
                durationString = lineDurationMiliseconds ? utils.formatDistanceStrict(0, lineDurationMiliseconds / 1000, {
                    roundingMethod: "floor",
                    unit: "second"
                }) : "";
            } else if (lineDuration < 60000) {
                durationString = lineDurationSeconds ? utils.formatDistanceStrict(0, lineDurationSeconds, {
                    roundingMethod: "floor",
                    unit: "second"
                }) : "";
            } else {
                durationString = [
                    lineDurationDays ? utils.formatDistanceStrict(0, lineDurationDays, {
                        roundingMethod: "floor",
                        unit: "day"
                    }) : "",
                    lineDurationHours ? utils.formatDistanceStrict(0, lineDurationHours, {
                        roundingMethod: "floor",
                        unit: "hour"
                    }) : "",
                    lineDurationMinutes && (!unresolvedCall || wide) ? utils.formatDistanceStrict(0, lineDurationMinutes, {
                        roundingMethod: "floor",
                        unit: "minute"
                    }) : "", 
                ].filter(function(value) {
                    return value;
                }).join(", ");
            }
        } else {
            durationString = t([
                "shared:forever"
            ], {
                defaultValue: "Forever"
            });
        }
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_card_box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            small: small,
            backgroundColor: statusColor,
            className: className,
            cardContentClass: classes.cardContentClass,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                className: className,
                variant: "body2",
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                    justifyContent: "center",
                    alignItems: "center",
                    color: theme.palette.getContrastText(statusColor)
                }, moreStyle),
                noWrap: true,
                children: [
                    " ".concat(stopText, " "),
                    showDuration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            durationString ? " - " : "",
                            durationString
                        ]
                    }),
                    !!unresolvedCall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_RingVolume__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__["default"])(classes.andonIndicator, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, classes.buttonUrgencyCritical, unresolvedCall === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .Urgency.CRITICAL */ .Tj.CRITICAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, classes.buttonUrgencyMedium, unresolvedCall === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_9__/* .Urgency.MEDIUM */ .Tj.MEDIUM), _obj))
                    }) : null
                ]
            })
        });
    };
    return LineStatus;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), _hocs__WEBPACK_IMPORTED_MODULE_17__/* .withUtils */ .W, (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(LineStatus));


/***/ }),

/***/ 35606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81666);
/* harmony import */ var _mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54936);
/* harmony import */ var _mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56646);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14724);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5887);


















var styles = function(theme) {
    var _obj;
    return {
        pagination: {
            alignItems: "center",
            marginLeft: "1em",
            display: "flex"
        },
        buttons: {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center"
        },
        rowsLabel: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            whiteSpace: "nowrap"
        }, theme.typography.caption), (_obj = {
            paddingRight: theme.spacing(5)
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
            paddingRight: "0"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "lineHeight", theme.spacing(5)), _obj)),
        button: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            color: "inherit",
            minWidth: theme.spacing(2),
            height: theme.spacing(5)
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        activeButton: {
            fontWeight: "bold",
            cursor: "default"
        },
        arrowButton: {
            transform: theme.direction === "rtl" ? "rotate(180deg)" : undefined
        }
    };
};
var PageButton = function(args) {
    var text = args.text, isActive = args.isActive, isDisabled = args.isDisabled, classes = args.classes, onClick = args.onClick;
    var _obj;
    var buttonClasses = (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.button, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.activeButton, isActive), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: buttonClasses,
        disabled: isDisabled,
        onClick: onClick,
        disableRipple: isActive,
        children: text
    });
};
var ellipsisSymbol = "…";
var Paginator = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Paginator, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Paginator);
    function Paginator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, Paginator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setPage = function(desiredPage) {
            return function() {
                return _this.props.onCurrentPageChange(desiredPage);
            };
        };
        _this.renderPageButtons = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, classes = _props.classes;
            var pageButtons = [];
            var maxButtonCount = 3;
            var startPage = 1;
            var endPage = totalPages || 1;
            if (maxButtonCount < totalPages) {
                startPage = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .calculateStartPage */ .kw6)(currentPage + 1, maxButtonCount, totalPages);
                endPage = startPage + maxButtonCount - 1;
            }
            if (startPage > 1) {
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(1),
                    classes: classes,
                    onClick: _this.setPage(0)
                }, 1));
                if (startPage > 2) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisStart"));
                }
            }
            for(var page = startPage; page <= endPage; page += 1){
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(page),
                    isActive: page === currentPage + 1,
                    classes: classes,
                    onClick: _this.setPage(page - 1),
                    isDisabled: startPage === endPage
                }, page));
            }
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisEnd"));
                }
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(totalPages),
                    classes: classes,
                    onClick: _this.setPage(totalPages - 1)
                }, totalPages));
            }
            return pageButtons;
        };
        _this.previousPage = function() {
            var _props = _this.props, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage > 0 && onCurrentPageChange(currentPage - 1);
        };
        _this.nextPage = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage < totalPages - 1 && onCurrentPageChange(currentPage + 1);
        };
        return _this;
    }
    var _proto = Paginator.prototype;
    _proto.render = function render() {
        var _props = this.props, totalPages = _props.totalPages, totalCount = _props.totalCount, pageSize = _props.pageSize, currentPage = _props.currentPage, classes = _props.classes, t = _props.t;
        var from = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .firstRowOnPage */ .dF$)(currentPage, pageSize, totalCount);
        var to = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .lastRowOnPage */ .ZN$)(currentPage, pageSize, totalCount);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.pagination,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.rowsLabel,
                    children: "".concat(from).concat(from < to ? "-".concat(to) : "", " ").concat(t([
                        "shared:pageOf"
                    ], {
                        defaultValue: "of"
                    }), " ").concat(totalCount)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === 0,
                            onClick: this.previousPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                        }),
                        this.renderPageButtons(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === totalPages - 1 || totalCount === 0,
                            onClick: this.nextPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            ]
        });
    };
    return Paginator;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles, {
    name: "Paginator"
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Paginator));


/***/ }),

/***/ 23387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52875);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5887);










var styles = function() {
    return {
        progressContainer: {
            height: "2em",
            width: "100%",
            position: "relative",
            border: "1px solid black"
        },
        smallProgressContainer: {
            height: "2em",
            width: "100%",
            position: "relative",
            border: "none",
            display: "flex",
            alignItems: "center"
        },
        progressText: {
            position: "absolute",
            top: "50%",
            marginTop: "-1em",
            width: "100%",
            textAlign: "center"
        },
        smallProgressText: {
            position: "absolute",
            width: "100%",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        smallInlineProgressText: {
            position: "absolute",
            width: "100%",
            display: "flex"
        },
        progressBarRed: {
            "&:after": {
                backgroundColor: "#ff5b5b",
                filter: "invert(1)"
            }
        },
        progressBarGreen: {
            "&:after": {
                backgroundColor: "#43a047",
                filter: "invert(1)",
                willChange: "opacity"
            }
        },
        progressBar: {
            height: "100%",
            position: "relative",
            width: "0%",
            transition: "1s width",
            "&:before, &:after": {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                position: "absolute",
                content: '""'
            },
            "&:before": {
                zIndex: 1,
                pointerEvents: "none",
                mixBlendMode: "difference",
                backgroundColor: "white"
            }
        },
        // Chrome, Safari, new Chrome-based Edge Browser and Firefox
        "@supports (-ms-ime-align:auto)": {
            progressBar: {
                "&:before": {
                    // Because mixBlendMode does not work in Edge, we need to disable the background color for Edge only.
                    backgroundColor: "transparent"
                }
            }
        },
        batchText: {
            fontSize: 20,
            marginBottom: "12px",
            textAlign: "center",
            width: "100%"
        },
        smallBatchText: {
            fontSize: "0.875rem",
            marginBottom: "0",
            textAlign: "center",
            width: "100%"
        }
    };
};
var Progress = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Progress, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Progress);
    function Progress() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Progress);
        return _super.apply(this, arguments);
    }
    var _proto = Progress.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, left = _props.left, right = _props.right, inlineTitle = _props.inlineTitle, completePercentage = _props.completePercentage, small = _props.small, _red = _props.red, red = _red === void 0 ? false : _red;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            elevation: 1,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: small ? classes.smallProgressContainer : classes.progressContainer,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "".concat(Math.min(100, completePercentage), "%")
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])(classes.progressBar, red ? classes.progressBarRed : classes.progressBarGreen)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: small ? classes.smallProgressText : classes.progressText,
                        children: inlineTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            className: small ? classes.smallBatchText : classes.batchText,
                            noWrap: true,
                            children: [
                                inlineTitle + ": ",
                                left,
                                " ",
                                left !== "" ? "/" : "",
                                " ",
                                right,
                                " "
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            className: small ? classes.smallBatchText : classes.batchText,
                            noWrap: true,
                            children: [
                                " ",
                                left,
                                " ",
                                left !== "" ? "/" : "",
                                " ",
                                right,
                                " "
                            ]
                        })
                    })
                ]
            })
        });
    };
    return Progress;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_9__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Progress));


/***/ }),

/***/ 89506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LineContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var LineContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    lineId: undefined,
    lineName: undefined
});


/***/ }),

/***/ 23415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isSearchValueType; }
/* harmony export */ });
var isSearchValueType = function(searchValue) {
    return searchValue.label !== undefined;
};


/***/ }),

/***/ 40510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ getDayEnumFromDay; },
/* harmony export */   "Dd": function() { return /* binding */ getShiftFromShifts; },
/* harmony export */   "VL": function() { return /* binding */ convertGenericShiftTimeToDatePair; },
/* harmony export */   "XS": function() { return /* binding */ getDaySortNumber; },
/* harmony export */   "bb": function() { return /* binding */ unrollSchedule; },
/* harmony export */   "dl": function() { return /* binding */ getYearWeek; },
/* harmony export */   "g_": function() { return /* binding */ getDayStringOfEnum; },
/* harmony export */   "ku": function() { return /* binding */ getDayNumberOfEnum; },
/* harmony export */   "yV": function() { return /* binding */ mkAppointmentsFromShifts; }
/* harmony export */ });
/* unused harmony exports extractCurrentSchedule, shiftDuration */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48417);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19852);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52108);





// CC-BY-CA: https://stackoverflow.com/a/6117889
var getYearWeek = function(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    // Return array of year and week number
    return {
        year: d.getUTCFullYear(),
        week: weekNo
    };
};
/**
 * Extract the schedule that is valid in the date you request. If not supplied
 * an array of schedules, it will return the schedule immediately.
 */ var extractCurrentSchedule = function(schedules, date) {
    var target = getYearWeek(date);
    if (!Array.isArray(schedules)) {
        return schedules;
    }
    // If we only have one schedule (usually the case from our request), we take it directly.
    if (schedules.length === 1) {
        return schedules[0];
    } else if (schedules.length > 1) {
        // If we are given more schedules, find the one that is the currently active one, based on the `validFrom` periods.
        var activeSchedule;
        schedules.map(function(schedule) {
            if (schedule.validFrom.year <= target.year && schedule.validFrom.week <= target.week) {
                // If no schedule has been set, just set the initial one.
                if (!activeSchedule) {
                    activeSchedule = schedule;
                    return;
                }
                // Check if the schedule's validFrom period is closer to our target, than the current `activeSchedule`.
                var scheduleYearDiff = target.year - schedule.validFrom.year;
                var activeScheduleYearDiff = target.year - activeSchedule.validFrom.year;
                var scheduleWeekDiff = target.week - schedule.validFrom.week;
                var activeScheduleWeekDiff = target.week - activeSchedule.validFrom.week;
                if (scheduleYearDiff <= activeScheduleYearDiff && scheduleWeekDiff < activeScheduleWeekDiff) {
                    activeSchedule = schedule;
                    return;
                }
            }
        });
        return activeSchedule;
    }
    return undefined;
};
/**
 * Convert a `DayOfWeek` enum to a string.
 */ var getDayStringOfEnum = function(t, dayOfWeek) {
    switch(dayOfWeek){
        case 0:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return t([
                "shared:sunday"
            ], {
                defaultValue: "Sunday"
            });
        case 1:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
        case 2:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return t([
                "shared:tuesday"
            ], {
                defaultValue: "Tuesday"
            });
        case 3:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return t([
                "shared:wednesday"
            ], {
                defaultValue: "Wednesday"
            });
        case 4:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return t([
                "shared:thursday"
            ], {
                defaultValue: "Thursday"
            });
        case 5:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return t([
                "shared:friday"
            ], {
                defaultValue: "Friday"
            });
        case 6:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return t([
                "shared:saturday"
            ], {
                defaultValue: "Saturday"
            });
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
    }
};
/**
 * Convert a day 'number' into a `DayOfWeek` enum.
 */ var getDayEnumFromDay = function(dayOfWeek) {
    switch(dayOfWeek){
        case 0:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
        case 1:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
        case 2:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY;
        case 3:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY;
        case 4:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY;
        case 5:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY;
        case 6:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY;
        default:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
    }
};
/**
 * Convert a `DayOfWeek` enum to a sortable number, rotating it based on `startDayOfWeek`.
 */ var getDaySortNumber = function(dayOfWeek) {
    var startDayOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
    // Figure out what the start day is so we can rotate by this number.
    var foundStartDay = getDayNumberOfEnum(startDayOfWeek);
    var sortNumber = 0;
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            sortNumber = 0 < foundStartDay ? 0 + 7 : 0;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            sortNumber = 1 < foundStartDay ? 1 + 7 : 1;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            sortNumber = 2 < foundStartDay ? 2 + 7 : 2;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            sortNumber = 3 < foundStartDay ? 3 + 7 : 3;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            sortNumber = 4 < foundStartDay ? 4 + 7 : 4;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            sortNumber = 5 < foundStartDay ? 5 + 7 : 5;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            sortNumber = 6 < foundStartDay ? 6 + 7 : 6;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            sortNumber = 1;
            break;
    }
    return sortNumber;
};
/**
 * Convert a `DayOfWeek` enum to a number. We default to Monday (i.e. 1).
 */ var getDayNumberOfEnum = function(dayOfWeek) {
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return 0;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return 1;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return 2;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return 3;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return 4;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return 5;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return 6;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return 1;
    }
};
/**
 * Convert a schedule shift element into a appointment element needed for the calendar widget.
 *
 * This part gets a little hairy. We need to convert the generic "Monday 8 - 16" into a specific
 * date on the calendar, based on the dates we are shown. Furthermore, these dates can change, depending
 * on the start day of the week that the user has configured.
 *
 * We first figure out if the calendar if the start day of the calendar is after our current date, which
 * will mean that the week view is shifted one week back.
 *
 * Then we take the day of the shift event, e.g. Monday, and subtract the start day, e.g. Tuesday. If
 * this day is lower than 0, we know that we are on a date before the start date, and we need to add 7
 * days to the result of this, because we previously accounted for the shift in the week view.
 *
 * Finally, we can get the dates from the current date + the shift in week view + the shift from start
 * date.
 */ var convertGenericShiftTimeToDatePair = function(timeRange, date, startDay) {
    var from = timeRange.from, to = timeRange.to;
    var dayOfStartDay = getDayNumberOfEnum(startDay);
    var dayOfShiftStart = getDayNumberOfEnum(from.day);
    var dayOfShiftEnd = getDayNumberOfEnum(to.day);
    var currentDayInWeek = date.getDay();
    if (dayOfShiftEnd < dayOfShiftStart) {
        dayOfShiftEnd += 7;
    }
    // If the start day is before the current day of the week, we must shift our days back.
    var shiftToLastWeek = 0;
    if (currentDayInWeek < dayOfStartDay) {
        // We shift it back a week, and then add the days in that week that has already passed.
        shiftToLastWeek = -7 + (dayOfStartDay - currentDayInWeek);
    } else {
        shiftToLastWeek = dayOfStartDay - currentDayInWeek;
    }
    // Shift the day of the shift based on the start day of the schedule.
    var shiftForStartDate = dayOfShiftStart - dayOfStartDay;
    if (shiftForStartDate < 0) {
        // If it's below 0, that's because it wrapped around, so we subtract the shift from 7.
        shiftForStartDate = 7 + shiftForStartDate;
    }
    // Finally, we create a new date from this shift in days.
    var shiftedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    shiftedDate.setDate(shiftedDate.getDate() + shiftToLastWeek + shiftForStartDate);
    var wrapShift = dayOfShiftEnd < dayOfShiftStart;
    var shiftShift = wrapShift ? dayOfShiftStart - 1 : dayOfShiftEnd - dayOfShiftStart;
    return {
        from: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate(), from.hour, from.minute),
        to: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate() + shiftShift, to.hour, to.minute)
    };
};
/**
 * Convert a shift into an appointment, for use with our DX Scheduler component. An
 * appointment looks something like (as a minimum):
 * ```
{
  title: 'Website Re-Design Plan',
  startDate: new Date(2019, 4, 15, 9, 30),
  endDate: new Date(2019, 4, 15, 11, 30),
  id: 0,
  location: 'Room 1',
}
```
 */ var mkAppointmentsFromShifts = function(shifts, date, startDay) {
    var ref = convertGenericShiftTimeToDatePair({
        from: {
            day: startDay,
            hour: 0,
            minute: 0
        },
        to: {
            day: startDay === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY ? generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY,
            hour: 23,
            minute: 59
        }
    }, date, startDay), scheduleStart = ref.from, scheduleEnd = ref.to;
    return shifts.reduce(function(shifts, shift) {
        // All this hackery is necessary because the devexpress framework does not support "appointments" that are longer
        // than `24 hours - 1ms`.
        // Shifts rotate on a week boundary, so we determine the chunks based off of the duration to consume - that is, if
        // the shift spans more than 24 hours, we split it into consecutive chunks.
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        // If DST starts during the span in the following week, make sure we use the end timezone rather than the following
        // week's when we circle back to the beginning.
        var endDateOffset = scheduleEnd.getTime() < endDate.getTime() ? scheduleEnd.getTimezoneOffset() : endDate.getTimezoneOffset();
        // We shift to local time to utilize modulus rings targetting 24 hours. This should also reveal any DST
        // changes. However, we use the calendar boundary if end spans into the following week.
        var shiftedStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 1..minutes);
        var shiftedEndDate = new Date(endDate.getTime() - endDateOffset * 1..minutes);
        var startSplit = shiftedStartDate.getTime();
        var durationToConsume = shiftedEndDate.getTime() - shiftedStartDate.getTime();
        while(0 < durationToConsume){
            // Subtract one to avoid extending into the following day - it's added back when subtracting the duration.
            var dayEnd = Math.ceil((startSplit + 1) / 24..hours) * 24..hours - 1;
            var startTimeOffset = new Date(startSplit).getTimezoneOffset() * 1..minutes;
            var partStartDate = new Date(startSplit + startTimeOffset);
            var timeTillMidnight = dayEnd - startSplit;
            var partEndDate = new Date(partStartDate.getTime() + Math.min(durationToConsume, timeTillMidnight));
            shifts.push({
                title: shift.name,
                id: shift.id,
                startDate: partStartDate,
                endDate: partEndDate,
                originalShift: shift
            });
            durationToConsume -= partEndDate.getTime() - partStartDate.getTime() + 1;
            // We don't need to shift the scheduleStart, since it's cancelled out after the rotation.
            startSplit = scheduleStart.getTime() + (startSplit - scheduleStart.getTime() + timeTillMidnight + 1) % 7..days;
        }
        return shifts;
    }, []);
};
var ref, ref1;
/**
 * We remap the whole schedule, to avoid all `__typename` fields.
 */ var unrollSchedule = function(schedule) {
    return {
        lineId: schedule === null || schedule === void 0 ? void 0 : schedule.lineId,
        validFrom: {
            year: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.year,
            week: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.week
        },
        isExceptionalWeek: (ref = schedule === null || schedule === void 0 ? void 0 : schedule.isExceptionalWeek) !== null && ref !== void 0 ? ref : false,
        shifts: ((ref1 = schedule === null || schedule === void 0 ? void 0 : schedule.shifts) !== null && ref1 !== void 0 ? ref1 : []).map(function(shift) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            return {
                id: shift.id,
                name: shift.name,
                description: shift.description,
                targets: {
                    oee: shift === null || shift === void 0 ? void 0 : (ref = shift.targets) === null || ref === void 0 ? void 0 : ref.oee,
                    oee2: shift === null || shift === void 0 ? void 0 : (ref1 = shift.targets) === null || ref1 === void 0 ? void 0 : ref1.oee2,
                    oee3: shift === null || shift === void 0 ? void 0 : (ref2 = shift.targets) === null || ref2 === void 0 ? void 0 : ref2.oee3,
                    tcu: shift === null || shift === void 0 ? void 0 : (ref3 = shift.targets) === null || ref3 === void 0 ? void 0 : ref3.tcu,
                    produced: shift === null || shift === void 0 ? void 0 : (ref4 = shift.targets) === null || ref4 === void 0 ? void 0 : ref4.produced,
                    numberOfBatches: shift === null || shift === void 0 ? void 0 : (ref5 = shift.targets) === null || ref5 === void 0 ? void 0 : ref5.numberOfBatches
                },
                timeRange: {
                    from: {
                        day: shift === null || shift === void 0 ? void 0 : (ref6 = shift.timeRange) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.from) === null || ref7 === void 0 ? void 0 : ref7.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref8 = shift.timeRange) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.from) === null || ref9 === void 0 ? void 0 : ref9.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref10 = shift.timeRange) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.from) === null || ref11 === void 0 ? void 0 : ref11.minute
                    },
                    to: {
                        day: shift === null || shift === void 0 ? void 0 : (ref12 = shift.timeRange) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.to) === null || ref13 === void 0 ? void 0 : ref13.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref14 = shift.timeRange) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.to) === null || ref15 === void 0 ? void 0 : ref15.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref16 = shift.timeRange) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.to) === null || ref17 === void 0 ? void 0 : ref17.minute
                    }
                }
            };
        })
    };
};
var getShiftFromShifts = function(shifts, date, startDay, options) {
    var target = (options === null || options === void 0 ? void 0 : options.target) || "current";
    // Bipolar offset, i.e.: -1, 0, 1
    var indexOffset = +(target === "previous") || -(target === "next");
    var sortedShifts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(shifts).sort(function(a, b) {
        var ref = convertGenericShiftTimeToDatePair(a.timeRange, date, startDay), dateA = ref.to;
        var ref1 = convertGenericShiftTimeToDatePair(b.timeRange, date, startDay), dateB = ref1.to;
        return dateA.getTime() - dateB.getTime();
    });
    var restructuredShifts = sortedShifts.map(function(shift) {
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        return {
            shift: shift,
            startDate: startDate,
            endDate: endDate
        };
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(restructuredShifts.slice(restructuredShifts.length - 1), 1), lastShift = ref[0];
    if (!lastShift) {
        return;
    }
    if ((lastShift.endDate.getDay() || 7) < (lastShift.startDate.getDay() || 7)) {
        restructuredShifts.unshift({
            shift: lastShift.shift,
            startDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.startDate, 7),
            endDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.endDate, 7)
        });
    }
    var index = restructuredShifts.reverse().findIndex(function(param) {
        var startDate = param.startDate;
        return startDate <= date;
    });
    return restructuredShifts[index + indexOffset];
};
var getWeekdayNumberSane = function(dayOfWeek) {
    switch(dayOfWeek){
        case "MONDAY":
            return 0;
        case "TUESDAY":
            return 1;
        case "WEDNESDAY":
            return 2;
        case "THURSDAY":
            return 3;
        case "FRIDAY":
            return 4;
        case "SATURDAY":
            return 5;
        case "SUNDAY":
            return 6;
        default:
            return 0;
    }
};
var shiftDuration = function(timeRange) {
    var _from = timeRange.from, fromDayEnum = _from.day, fromHour = _from.hour, fromMinute = _from.minute, _to = timeRange.to, toDayEnum = _to.day, toHour = _to.hour, toMinute = _to.minute;
    // NOTE: Shift it by one day, just to make sure we don't end up at a zero-day
    // (1970-01-00)
    var fromDay = getWeekdayNumberSane(fromDayEnum) + 1;
    var toDay = getWeekdayNumberSane(toDayEnum) + 1;
    if (toDay < fromDay) {
        toDay += 7;
    }
    var fromTimestamp = new Date([
        "1970-01-",
        [
            fromDay,
            fromHour,
            fromMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    var toTimestamp = new Date([
        "1970-01-",
        [
            toDay,
            toHour,
            toMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    return toTimestamp - fromTimestamp;
};


/***/ }),

/***/ 98156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withIAM; },
/* harmony export */   "y": function() { return /* binding */ withIAMPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59843);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardActions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98021);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89879);
/* harmony import */ var _contexts_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46036);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5887);
/* harmony import */ var _lib_features__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53541);




















// FIXME: Correct the user context signature...
// tslint:disable:max-classes-per-file
var withIAM = function(WrappedComponent) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMWrapper, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMWrapper);
        function WithIAMWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithIAMWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                children: function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        user: user,
                        features: user.features,
                        hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                        hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                        hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                        hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                        hasFeatureInAnyUserPool: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)
                    }, _this.props));
                }
            });
        };
        return WithIAMWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};
var styles = function(theme) {
    return {
        card: {
            width: "100%",
            maxWidth: "500px"
        },
        fillHeight: {
            height: "100%"
        },
        title: {
            marginBottom: theme.spacing(2)
        }
    };
};
var withIAMPage = function(lookupFeatures, featureType) {
    var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "group";
    return function(WrappedComponent) {
        var WithIAMPageWrapper = /*#__PURE__*/ function(_Component) {
            "use strict";
            (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMPageWrapper, _Component);
            var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMPageWrapper);
            function WithIAMPageWrapper() {
                (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMPageWrapper);
                return _super.apply(this, arguments);
            }
            var _proto = WithIAMPageWrapper.prototype;
            _proto.render = function render() {
                var _props = this.props, classes = _props.classes, t = _props.t, i18n = _props.i18n, tReady = _props.tReady, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
                    "classes",
                    "t",
                    "i18n",
                    "tReady"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                    children: function(_param) {
                        var status = _param.status, user = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                            "status"
                        ]);
                        var allowed = scope === "userPool" ? _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)(lookupFeatures, featureType) : _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)(lookupFeatures, featureType);
                        var wrappedMessage;
                        if (!status.loading && user && user.features && !allowed) {
                            wrappedMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                className: classes.fillHeight,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    className: classes.fillHeight,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: classes.card,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            variant: "h5",
                                                            className: classes.title,
                                                            children: t([
                                                                "shared:unfortunatelyNoPermission"
                                                            ], {
                                                                defaultValue: "Unfortunately, you don't have permission to view this page!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            children: t([
                                                                "shared:contactYourLocalAdminIfWrong"
                                                            ], {
                                                                defaultValue: "If you believe this is a mistake, contact your local administrator, and they can grant you access."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardActions__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                        href: {
                                                            pathname: "/"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            color: "primary",
                                                            children: t([
                                                                "shared:returnToFrontPage"
                                                            ], {
                                                                defaultValue: "Return to front page"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            loading: status.loading,
                            error: status.error,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                features: user.features,
                                hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                                hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                                hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                                hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)
                            }, restProps))
                        });
                    }
                });
            };
            return WithIAMPageWrapper;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_18__/* .withTranslation */ .Z)([
            "shared"
        ]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_19__/* .withStyles */ .D)(styles));
        return enhance(WithIAMPageWrapper);
    };
};


/***/ }),

/***/ 41440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ withLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _contexts_line__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89506);







// tslint:disable:max-classes-per-file
var withLine = function(WrappedComponent) {
    return /*#__PURE__*/ function(_PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(WithLineWrapper, _PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WithLineWrapper);
        function WithLineWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, WithLineWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithLineWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_line__WEBPACK_IMPORTED_MODULE_5__/* .LineContext.Consumer */ .t.Consumer, {
                children: function(param) {
                    var lineId = param.lineId, lineName = param.lineName;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        lineId: lineId,
                        lineName: lineName
                    }, _this.props));
                }
            });
        };
        return WithLineWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
};


/***/ }),

/***/ 81861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ withUtils; },
/* harmony export */   "n": function() { return /* binding */ useUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14478);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54765);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28879);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84984);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25655);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68568);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84358);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36712);







var additionalUtils = function(locale) {
    return {
        formatDistance: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatDistanceStrict: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatRelative: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatWeekdays: function(formatString) {
            var now = new Date();
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                start: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                }),
                end: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                })
            }).map(function(day) {
                return (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(day, formatString, {
                    locale: locale
                });
            });
        }
    };
};
var useUtils = function() {
    var utils = new _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    return Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")));
};
var withUtils = function(WrappedComponent) {
    return function(props) {
        var utils = useUtils();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            utils: Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")))
        }));
    };
};


/***/ }),

/***/ 27703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _stop_type_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43078);

var translateStoptypename = function(t, lineCause) {
    if ((0,_stop_type_names__WEBPACK_IMPORTED_MODULE_0__/* .stopTypeNames */ .R)(t)[lineCause]) {
        return (0,_stop_type_names__WEBPACK_IMPORTED_MODULE_0__/* .stopTypeNames */ .R)(t)[lineCause];
    } else {
        return lineCause;
    }
};
var getLineStatusInfo = function(t, theme, lineStatus, lineDuration, stopRegisterThresholdInMillis, lineCause, unresolvedCall) {
    switch(lineStatus){
        case "OFF":
            return {
                statusColor: "#8e24aa",
                statusText: t([
                    "batches:statusOffline"
                ], {
                    defaultValue: "Offline"
                }),
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "DOWNTIME":
            if (lineDuration >= stopRegisterThresholdInMillis) {
                return {
                    statusColor: "#d32f2f",
                    statusText: translateStoptypename(t, lineCause),
                    lineDuration: lineDuration,
                    unresolvedCall: unresolvedCall
                };
            } else {
                return {
                    statusColor: "#43a047",
                    statusText: t([
                        "batches:statusPending"
                    ], {
                        defaultValue: "Pending"
                    }),
                    lineDuration: lineDuration,
                    unresolvedCall: unresolvedCall
                };
            }
        case "NO_ACT":
            return {
                statusColor: theme.blackbird.stops.NO_ACT.color.normal,
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "NON_PROD":
            return {
                statusColor: "#62757f",
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "BATCH_NON_PROD":
            return {
                statusColor: theme.blackbird.stops.BATCH_NON_PROD.color.normal,
                statusText: lineCause,
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        case "RUNNING":
            return {
                statusColor: "#43a047",
                statusText: t([
                    "batches:statusRunning"
                ], {
                    defaultValue: "Running"
                }),
                lineDuration: lineDuration,
                unresolvedCall: unresolvedCall
            };
        default:
            return {
                statusColor: "#fff",
                statusText: "",
                lineDuration: 0,
                unresolvedCall: unresolvedCall
            };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getLineStatusInfo);


/***/ }),

/***/ 34614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ updateDataHash; },
/* harmony export */   "u": function() { return /* binding */ hashCode; }
/* harmony export */ });
var hashCode = function(s) {
    var hash = 0;
    if (!(s === null || s === void 0 ? void 0 : s.length)) {
        return String(hash);
    }
    for(var i = 0; i < s.length; i++){
        var char = s.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + char;
        // eslint-disable-next-line no-bitwise
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash);
};
var updateDataHash = function(setDataHash) {
    return function(data) {
        if (data) {
            var hash = hashCode(JSON.stringify(data));
            setDataHash(hash);
        }
    };
};


/***/ }),

/***/ 43078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ stopTypeNames; }
/* harmony export */ });
var stopTypeNames = function(t) {
    return {
        DOWNTIME: t([
            "stop:lossDuringOperation"
        ], {
            defaultValue: "Loss During Operation"
        }),
        NO_ACT: t([
            "stop:noActivityAtLine"
        ], {
            defaultValue: "No Activity at Line"
        }),
        NON_PROD: t([
            "stop:nonProductionActivities"
        ], {
            defaultValue: "Non-production Activities"
        }),
        BATCH_NON_PROD: t([
            "stop:batchSpecificNonOperation"
        ], {
            defaultValue: "Batch-specific Non-operation"
        }),
        UNREGISTERED: t([
            "shared:unregistered"
        ], {
            defaultValue: "Unregistered"
        }),
        MICRO_STOP: t([
            "shared:microStop"
        ], {
            defaultValue: "Micro stop"
        })
    };
};


/***/ }),

/***/ 27443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ lines; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/index.js + 18 modules
var es = __webpack_require__(59843);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(61431);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/hooks/use-local-storage.js
var use_local_storage = __webpack_require__(89641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(20960);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(14724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(18691);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(46556);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(3192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mdi-material-ui@7.7.0_@mui+material@5.12.0_react@17.0.2/node_modules/mdi-material-ui/ViewQuilt.js
var ViewQuilt = __webpack_require__(27625);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(62471);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./hocs/with-clock.tsx
var with_clock = __webpack_require__(83685);
;// CONCATENATED MODULE: ./components/buttons/countdown-button.tsx





var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        progress: {
            marginTop: "-4px"
        }
    };
});
var CountdownButton = function(param) {
    var children = param.children, loading = param.loading, overrideContainerStyle = param.overrideContainerStyle, overrideProgressStyle = param.overrideProgressStyle, nextLiveUpdate = param.nextLiveUpdate, updateInterval = param.updateInterval;
    var classes = useStyles().classes;
    var ref = (0,react.useContext)(with_clock/* ClockContext */.n_), currentTime = ref.currentTime, start = ref.start;
    (0,react.useEffect)(function() {
        start();
    }, []);
    var timeUntilNextLiveUpdate = nextLiveUpdate ? nextLiveUpdate.getTime() - currentTime.getTime() : 0;
    var liveProgress;
    if (updateInterval === null) {
        liveProgress = 0;
    } else if (timeUntilNextLiveUpdate <= 0) {
        liveProgress = 0;
    } else if (updateInterval <= timeUntilNextLiveUpdate) {
        liveProgress = 100;
    } else {
        liveProgress = 100 - (updateInterval - timeUntilNextLiveUpdate) / updateInterval * 100;
    }
    if (loading) {
        liveProgress = 100;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: overrideContainerStyle,
        children: [
            children,
            nextLiveUpdate !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                className: classes.progress,
                variant: loading ? "query" : "determinate",
                value: liveProgress,
                style: overrideProgressStyle
            })
        ]
    });
};
/* harmony default export */ var countdown_button = (CountdownButton);

// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./views/lines/overview-components/menu.tsx




















var styles = function(theme) {
    return {
        betaContainer: {
            position: "absolute",
            top: "7px",
            right: "2px"
        },
        betaText: {
            fontSize: "0.6rem"
        },
        menuItemTitle: {
            color: theme.palette.text.primary
        },
        menuItemStyles: {
            padding: theme.spacing(0)
        }
    };
};
var instanceOfCardConf = function(object) {
    return "showGraph" in object && "showBatchProduct" in object && "showLineStatus" in object && "showBatchProductNumber" in object && "showBatchProgress" in object;
};
var defaultCardConf = {
    showGraph: true,
    showLineStatus: false,
    showBatchProgress: false,
    showBatchProgressPercentage: false,
    showBatchProduct: false,
    showBatchProductNumber: false,
    showEstimatedTimeOfCompletion: false,
    showBatchNumber: false,
    timeInterval: 8,
    refreshInterval: 5..minutes,
    showStops: false,
    showStopLabels: false,
    showOee: false,
    countUnregisteredStops: false,
    oneLineCardEachRow: false,
    unresolvedAndonCalls: false,
    showWeeklyProgress: false,
    showDailyProgress: false
};
var mkTimeIntervalTranslation = function(t, interval) {
    if (interval === 0.5) {
        return t([
            "line:nMinutesTimeInterval"
        ], {
            defaultValue: "{{minutes}} minutes time interval",
            minutes: 30
        });
    }
    return t([
        "line:nHourTimeInterval"
    ], {
        defaultValue: "{{hour}} hour time interval",
        hour: interval
    });
};
var TimeIntervalMenuItem = function(props) {
    var t = props.t, interval = props.interval, cardConf = props.cardConf, handleCheck = props.handleCheck, classes = props.classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
        onClick: handleCheck(interval),
        className: classes.menuItemStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    color: "primary",
                    checked: cardConf && cardConf.timeInterval === interval ? true : false,
                    onChange: handleCheck(interval),
                    tabIndex: -1,
                    disableRipple: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: mkTimeIntervalTranslation(t, interval)
            })
        ]
    });
};
var RefreshIntervalMenuItem = function(props) {
    var label = props.label, interval = props.interval, cardConf = props.cardConf, handleCheck = props.handleCheck, classes = props.classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
        onClick: handleCheck(interval),
        className: classes.menuItemStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    color: "primary",
                    checked: cardConf && cardConf.refreshInterval === interval ? true : false,
                    onChange: handleCheck(interval),
                    tabIndex: -1,
                    disableRipple: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: label
            })
        ]
    });
};
var ConfigurationMenu = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ConfigurationMenu, _Component);
    var _super = (0,_create_super/* default */.Z)(ConfigurationMenu);
    function ConfigurationMenu() {
        (0,_class_call_check/* default */.Z)(this, ConfigurationMenu);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            menuAnchorEl: null
        };
        _this.handleMenuClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                menuAnchorEl: e.currentTarget
            });
        };
        _this.handleMenuClose = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.localStorage.setValue(_this.props.cardConf);
            // NOTE: The fetch below sets the configuration as a cookie, but we prefer local storage instead.
            // fetch('/config?data=' + encodeURIComponent(JSON.stringify(this.props.cardConf)), { method: 'POST' });
            _this.setState({
                menuAnchorEl: null
            });
        };
        _this.handleCheck = function(key) {
            return function() {
                var check = _this.props.cardConf[key];
                _this.props.updateConf(key, !check);
            };
        };
        _this.handleIntervalCheck = function(interval) {
            return function() {
                _this.props.updateIntervalConf(interval);
            };
        };
        _this.handleRefreshIntervalCheck = function(newInterval) {
            return function() {
                _this.props.updateRefreshIntervalConf(newInterval);
            };
        };
        return _this;
    }
    var _proto = ConfigurationMenu.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.cardConf !== this.props.cardConf || nextState.menuAnchorEl !== this.state.menuAnchorEl || nextProps.updateInterval !== this.props.updateInterval || nextProps.nextLiveUpdate !== this.props.nextLiveUpdate) {
            return true;
        }
        return false;
    };
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, t = _props.t, cardConf = _props.cardConf, updateInterval = _props.updateInterval, nextLiveUpdate = _props.nextLiveUpdate;
        var open = Boolean(this.state.menuAnchorEl);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(countdown_button, {
                    updateInterval: updateInterval,
                    nextLiveUpdate: nextLiveUpdate,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: t([
                            "shared:configurePersonalOverview"
                        ], {
                            defaultValue: "Configure your personal overview"
                        }),
                        placement: "left-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            "aria-label": "More",
                            "aria-owns":  false ? 0 : undefined,
                            "aria-haspopup": "true",
                            onClick: this.handleMenuClick,
                            size: "large",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewQuilt/* default */.Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                    id: "configuration-menu",
                    anchorEl: this.state.menuAnchorEl,
                    open: open,
                    keepMounted: true,
                    onClose: this.handleMenuClose,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            dense: true,
                            disabled: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                classes: {
                                    secondary: classes.menuItemTitle
                                },
                                secondary: t([
                                    "line:showOrHideComponents"
                                ], {
                                    defaultValue: "Show or hide components"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showGraph"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showGraph,
                                        onChange: this.handleCheck("showGraph"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showGraph"
                                    ], {
                                        defaultValue: "Show graph"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showLineStatus"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showLineStatus,
                                        onChange: this.handleCheck("showLineStatus"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showLineStatus"
                                    ], {
                                        defaultValue: "Show line status"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showBatchProgress"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showBatchProgress,
                                        onChange: this.handleCheck("showBatchProgress"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showBatchProgress"
                                    ], {
                                        defaultValue: "Show batch progress"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showBatchProgressPercentage"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showBatchProgressPercentage,
                                        onChange: this.handleCheck("showBatchProgressPercentage"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showBatchProgressPercentage"
                                    ], {
                                        defaultValue: "Show batch progress (in percentage)"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showBatchNumber"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showBatchNumber,
                                        onChange: this.handleCheck("showBatchNumber"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showBatchNumber"
                                    ], {
                                        defaultValue: "Show batch number"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showBatchProduct"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showBatchProduct,
                                        onChange: this.handleCheck("showBatchProduct"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showBatchProduct"
                                    ], {
                                        defaultValue: "Show product"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showBatchProductNumber"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showBatchProductNumber,
                                        onChange: this.handleCheck("showBatchProductNumber"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showBatchProductNumber"
                                    ], {
                                        defaultValue: "Show product number"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showEstimatedTimeOfCompletion"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showEstimatedTimeOfCompletion,
                                        onChange: this.handleCheck("showEstimatedTimeOfCompletion"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "line:showEstimatedTimeOfCompletion"
                                    ], {
                                        defaultValue: "Show estimated time of completion"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showStops"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showStops,
                                        onChange: this.handleCheck("showStops"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "shared:showStops"
                                    ], {
                                        defaultValue: "Show stops on chart"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showStopLabels"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showStopLabels,
                                        onChange: this.handleCheck("showStopLabels"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "shared:showStopLabels"
                                    ], {
                                        defaultValue: "Show stop labels"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("countUnregisteredStops"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.countUnregisteredStops,
                                        onChange: this.handleCheck("countUnregisteredStops"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "shared:countUnregisteredStops"
                                    ], {
                                        defaultValue: "Show unregistered stops count"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showOee"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showOee,
                                        onChange: this.handleCheck("showOee"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "shared:showOee"
                                    ], {
                                        defaultValue: "Show OEE"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("unresolvedAndonCalls"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.unresolvedAndonCalls,
                                        onChange: this.handleCheck("unresolvedAndonCalls"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "andon:showUnresolvedAndonCalls"
                                    ], {
                                        defaultValue: "Show unresolved Andon calls"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showWeeklyProgress"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showWeeklyProgress,
                                        onChange: this.handleCheck("showWeeklyProgress"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "lines:showWeeklyProgess"
                                    ], {
                                        defaultValue: "Show weekly progress"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("showDailyProgress"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.showDailyProgress,
                                        onChange: this.handleCheck("showDailyProgress"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "lines:showDailyProgess"
                                    ], {
                                        defaultValue: "Show daily progress"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            onClick: this.handleCheck("oneLineCardEachRow"),
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        color: "primary",
                                        checked: cardConf.oneLineCardEachRow,
                                        onChange: this.handleCheck("oneLineCardEachRow"),
                                        tabIndex: -1,
                                        disableRipple: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: t([
                                        "shared:oneLineCardEachRow"
                                    ], {
                                        defaultValue: "Show one Line per row"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            dense: true,
                            disabled: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                classes: {
                                    secondary: classes.menuItemTitle
                                },
                                secondary: t([
                                    "line:setTimeInterval"
                                ], {
                                    defaultValue: "Set the time interval"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 0.5,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 4,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 8,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 16,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 24,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 48,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIntervalMenuItem, {
                            t: t,
                            classes: classes,
                            interval: 72,
                            cardConf: cardConf,
                            handleCheck: this.handleIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            dense: true,
                            disabled: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                classes: {
                                    secondary: classes.menuItemTitle
                                },
                                secondary: t([
                                    "line:setRefreshTimeInterval"
                                ], {
                                    defaultValue: "Set the refresh interval"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIntervalMenuItem, {
                            label: t([
                                "line:everyMinuteRefreshInterval"
                            ], {
                                defaultValue: "Refresh every minute"
                            }),
                            classes: classes,
                            interval: 1..minutes,
                            cardConf: cardConf,
                            handleCheck: this.handleRefreshIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIntervalMenuItem, {
                            label: t([
                                "line:pluralMinutesRefreshInterval"
                            ], {
                                defaultValue: "Refresh every {{minutes}} minutes",
                                minutes: 5
                            }),
                            classes: classes,
                            interval: 5..minutes,
                            cardConf: cardConf,
                            handleCheck: this.handleRefreshIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIntervalMenuItem, {
                            label: t([
                                "line:pluralMinutesRefreshInterval"
                            ], {
                                defaultValue: "Refresh every {{minutes}} minutes",
                                minutes: 10
                            }),
                            classes: classes,
                            interval: 10..minutes,
                            cardConf: cardConf,
                            handleCheck: this.handleRefreshIntervalCheck
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIntervalMenuItem, {
                            label: t([
                                "line:noRefreshInterval"
                            ], {
                                defaultValue: "No refresh"
                            }),
                            classes: classes,
                            interval: null,
                            cardConf: cardConf,
                            handleCheck: this.handleRefreshIntervalCheck
                        })
                    ]
                })
            ]
        });
    };
    return ConfigurationMenu;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(styles), (0,use_local_storage/* withLocalStorage */.C1)(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ, defaultCardConf));
/* harmony default export */ var menu = (enhance(ConfigurationMenu));

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(88802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(54524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(78344);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(66637);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(13515);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(25998);
// EXTERNAL MODULE: ./components/buttons/sticky-fab.tsx
var sticky_fab = __webpack_require__(4228);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(94167);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(67844);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(30509);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(26561);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Step/Step.js
var Step = __webpack_require__(77801);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/StepLabel/StepLabel.js
var StepLabel = __webpack_require__(41292);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Stepper/Stepper.js
var Stepper = __webpack_require__(99158);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(60840);
// EXTERNAL MODULE: ./components/loading/overlay-spinner.tsx
var overlay_spinner = __webpack_require__(59967);
// EXTERNAL MODULE: ./graphql/mutations/line-create.gql
var line_create = __webpack_require__(65868);
var line_create_default = /*#__PURE__*/__webpack_require__.n(line_create);
// EXTERNAL MODULE: ./graphql/queries/sensor-groups.gql
var sensor_groups = __webpack_require__(18828);
var sensor_groups_default = /*#__PURE__*/__webpack_require__.n(sensor_groups);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(52108);
// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/line-list-topology.tsx + 1 modules
var line_list_topology = __webpack_require__(30182);
// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/select-sensor.tsx
var select_sensor = __webpack_require__(3911);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(16066);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(74110);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(33804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(67815);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(9734);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(35458);
// EXTERNAL MODULE: ./hooks/use-iam.tsx
var use_iam = __webpack_require__(12872);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/select-sensor-group.tsx























var select_sensor_group_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        content: {
            flexWrap: "wrap"
        },
        divider: {
            height: "5px",
            margin: "30px 0"
        },
        groupItem: {
            marginLeft: "0px",
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row"
        },
        accordion: {
            flex: "1",
            transition: "box-shadow .25s",
            "&:hover": {
                cursor: "pointer",
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        accordionDisabled: {
            color: "grey",
            backgroundColor: "#d3d3d3",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            },
            flex: "auto"
        },
        cardEmpty: {
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        sensorChip: (_obj = {
            margin: theme.spacing(0.5),
            color: "#000000"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            maxWidth: "100px"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            maxWidth: "200px"
        }), _obj),
        lineTakenExplanation: {
            marginBottom: theme.spacing()
        },
        radioButton: {
            paddingLeft: "0"
        }
    };
});
var SelectSensorGroup = function(param) {
    var selectedGroup = param.selectedGroup, onSelectSensorGroup = param.onSelectSensorGroup;
    var classes = select_sensor_group_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var iam = (0,use_iam/* useIAM */.e)();
    var width = (0,use_width/* useWidth */.z)();
    var ref1 = (0,react.useState)([]), groups = ref1[0], setGroups = ref1[1];
    var ref2 = (0,react.useState)([]), enabledGroups = ref2[0], setEnabledGroups = ref2[1];
    var ref3 = (0,react.useState)([]), disabledGroups = ref3[0], setDisabledGroups = ref3[1];
    var ref4 = (0,react.useState)([]), emptyGroups = ref4[0], setEmptyGroups = ref4[1];
    var ref5 = (0,react.useState)(false), expandedGroup = ref5[0], setExpandedGroup = ref5[1];
    var ref6 = (0,client.useQuery)((sensor_groups_default()), {
        partialRefetch: true,
        ssr: false,
        errorPolicy: "all",
        onCompleted: function(res) {
            return setGroups(res.company.groups.map(function(group) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, group), {
                    availableSensors: group.sensors.filter(function(s) {
                        return s && !sensorIsPartOfLine(s);
                    }),
                    unavailableSensors: group.sensors.filter(function(s) {
                        return s && sensorIsPartOfLine(s);
                    })
                });
            }));
        }
    }), data = ref6.data, loading = ref6.loading, error = ref6.error;
    (0,react.useEffect)(function() {
        if (groups.length === 0) {
            return;
        }
        var sortedGroups = sortGroupsByName(groups);
        var filteredGroups = sortedGroups.filter(function(group) {
            return iam.hasGroupFeatures(group.id, [
                "Lines.Line",
                "Lines.Group"
            ], "M");
        });
        var newEnabledGroups = filteredGroups.filter(function(group) {
            var ref;
            return 0 < (((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) || 0);
        });
        var newDisabledGroups = filteredGroups.filter(function(group) {
            var ref, ref1;
            return ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0;
        });
        var newEmptyGroups = filteredGroups.filter(function(group) {
            var ref, ref1;
            return ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) === 0;
        });
        setEnabledGroups(newEnabledGroups);
        setDisabledGroups(newDisabledGroups);
        setEmptyGroups(newEmptyGroups);
        if (newEnabledGroups.length > 0 && !(width === "sm" || width === "xs")) {
            setExpandedGroup(newEnabledGroups[0].id);
        }
    }, [
        groups
    ]);
    if (!data || !data.company || !data.company.groups) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
            loading: loading,
            error: error
        });
    }
    var onSelectGroup = function(group) {
        onSelectSensorGroup((selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id) === group.id ? null : group);
    };
    var renderSensorGroup = function(group) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SensorGroup, {
            group: group,
            selectedGroupId: selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id,
            expandedGroupId: expandedGroup,
            onSelectGroup: onSelectGroup,
            onExpandedChange: function(newExpandedGroup) {
                return setExpandedGroup(newExpandedGroup);
            }
        }, "group-".concat(group.id));
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
            loading: loading
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "caption",
                className: classes.lineTakenExplanation,
                display: "block",
                children: [
                    t([
                        "line:explanationLinesLikeTheFollowing"
                    ], {
                        defaultValue: "Sensors looking like the following:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            children: t([
                                "line:sensorName"
                            ], {
                                defaultValue: "Sensor name"
                            }).toLowerCase()
                        }),
                        color: "default"
                    }),
                    " ",
                    t([
                        "line:explanationAlreadyTaken"
                    ], {
                        defaultValue: ", are already part of a line, and cannot be added to a new one."
                    })
                ]
            }),
            enabledGroups.map(renderSensorGroup),
            disabledGroups.map(renderSensorGroup),
            emptyGroups.map(renderSensorGroup)
        ]
    });
};
var SensorGroup = function(props) {
    var ref, ref1, ref2, ref3;
    var group = props.group, selectedGroupId = props.selectedGroupId, expandedGroupId = props.expandedGroupId, onSelectGroup = props.onSelectGroup, onExpandedChange = props.onExpandedChange;
    var classes = select_sensor_group_useStyles().classes;
    var groupIsDisabled = ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0;
    var groupIsEmpty = ((ref2 = group.availableSensors) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && ((ref3 = group.unavailableSensors) === null || ref3 === void 0 ? void 0 : ref3.length) === 0;
    var onAccordionChange = function(groupId) {
        return function(event, isExpanded) {
            onExpandedChange(isExpanded ? groupId : false);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.groupItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                onClick: function() {
                    return onSelectGroup(group);
                },
                disabled: groupIsDisabled || groupIsEmpty,
                checked: selectedGroupId === group.id,
                color: "primary",
                className: classes.radioButton
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                elevation: 3,
                expanded: expandedGroupId === group.id,
                onChange: onAccordionChange(group.id),
                className: groupIsDisabled || groupIsEmpty ? classes.accordionDisabled : classes.accordion,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                        "aria-controls": "panel1bh-content",
                        id: "panel1bh-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "".concat(group.name, " ").concat(groupIsDisabled || groupIsEmpty ? " - " + " no available sensors " : "")
                        })
                    }, "summary-" + group.id),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        className: classes.content,
                        onClick: function() {
                            return onSelectGroup(group);
                        },
                        children: groupIsEmpty ? null : sortSensorByAvailability(group.sensors.filter(helper_types/* isTruthy */.f)).map(function(sensor) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SensorItem, {
                                sensor: sensor,
                                groupName: group.name
                            }, "sensor-".concat(sensor.peripheralId));
                        })
                    }, "details-" + group.id)
                ]
            }, "accordion-" + group.id)
        ]
    }, "div-" + group.id);
};
var SensorItem = function(props) {
    var sensor = props.sensor, groupName = props.groupName;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var classes = select_sensor_group_useStyles().classes;
    if (!sensor) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        placement: "top",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: sensor.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                sensor.description,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                sensorIsPartOfLine(sensor) ? t([
                    "line:partOfLine"
                ], {
                    defaultValue: "Part of line"
                }) : t([
                    "shared:available"
                ], {
                    defaultValue: "Available"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: sensor.name,
            variant: sensorIsPartOfLine(sensor) ? "filled" : "outlined",
            color: sensorIsPartOfLine(sensor) ? "default" : "primary",
            className: classes.sensorChip
        }, groupName + sensor.name)
    }, "".concat(groupName, "-select-sensor-group-").concat(sensor.name, "-").concat(sensor.peripheralId));
};
var sensorIsPartOfLine = function(sensor) {
    var ref, ref1;
    return !!(sensor === null || sensor === void 0 ? void 0 : (ref = sensor.peripheralInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.peripheralId);
};
var sortGroupsByName = function(groups) {
    var sortedGroups = (0,_to_consumable_array/* default */.Z)(groups);
    sortedGroups.sort(function(group1, group2) {
        return group1.name.localeCompare(group2.name);
    });
    return sortedGroups;
};
var sortSensorByAvailability = function(sensors) {
    var sortedSensors = (0,_to_consumable_array/* default */.Z)(sensors);
    sortedSensors.sort(function(sensor1, sensor2) {
        if (sensorIsPartOfLine(sensor1) && !sensorIsPartOfLine(sensor2)) {
            return 1;
        } else if (!sensorIsPartOfLine(sensor1) && sensorIsPartOfLine(sensor2)) {
            return -1;
        } else {
            return (sensor1 === null || sensor1 === void 0 ? void 0 : sensor1.name.localeCompare((sensor2 === null || sensor2 === void 0 ? void 0 : sensor2.name) || "")) || 0;
        }
    });
    return sortedSensors;
};
/* harmony default export */ var select_sensor_group = (SelectSensorGroup);

// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/specify-line-info.tsx
var specify_line_info = __webpack_require__(17649);
;// CONCATENATED MODULE: ./components/dialogs/create-line/create-line-dialog.tsx































var create_line_dialog_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        step: {
            maxHeight: "80px"
        },
        stepper: {
            maxHeight: "90px",
            paddingTop: "0px",
            paddingBottom: "10px"
        },
        stepContent: {
            flexGrow: 1
        },
        backButton: {
            marginRight: theme.spacing()
        },
        dialogSize: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            minWidth: "100% !important",
            minHeight: "100%"
        }),
        dialogBackgroundColor: {
            backgroundColor: "#fafafa",
            outlineStyle: "none"
        }
    };
});
var CreateLineDialog = function(param) {
    var handleOpenClose = param.handleOpenClose, open = param.open;
    var classes = create_line_dialog_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = (0,react.useState)(0), activeStep = ref1[0], setActiveStep = ref1[1];
    var ref2 = (0,react.useState)(null), sensorGroup = ref2[0], setSensorGroup = ref2[1];
    var ref3 = (0,react.useState)(null), bottleneckSensor = ref3[0], setBottleneckSensor = ref3[1];
    var ref4 = (0,react.useState)([]), nodes = ref4[0], setNodes = ref4[1];
    var ref5 = (0,react.useState)([]), links = ref5[0], setLinks = ref5[1];
    var ref6 = (0,react.useState)({
        name: "",
        description: ""
    }), lineInfo = ref6[0], setLineInfo = ref6[1];
    var ref7 = (0,react.useState)(true), nextButtonDisabled = ref7[0], setNextButtonDisabled = ref7[1];
    var steps = [
        t([
            "line:selectSensorGroup"
        ], {
            defaultValue: "Select a sensor group"
        }),
        t([
            "line:createLine"
        ], {
            defaultValue: "Create line"
        }),
        t([
            "line:describeLineTopology"
        ], {
            defaultValue: "Line composition (optional)"
        }),
        t([
            "line:lineSetupFinished"
        ], {
            defaultValue: "Finished line setup"
        }), 
    ];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((line_create_default())), 2), createLine = ref8[0], loading = ref8[1].loading;
    (0,react.useEffect)(function() {
        if (activeStep === 0) {
            resetState();
        }
    }, [
        activeStep
    ]);
    (0,react.useEffect)(function() {
        var disabled = true;
        switch(activeStep){
            case 0:
                disabled = !sensorGroup;
                break;
            case 1:
                disabled = !(bottleneckSensor && lineInfo.name);
                break;
            case 2:
                disabled = false;
                break;
            case 3:
                disabled = true;
                break;
            default:
                console.error("Unrecognized step! Value: " + activeStep + " Type: " + (typeof activeStep === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(activeStep)));
                break;
        }
        setNextButtonDisabled(disabled);
    }, [
        activeStep,
        sensorGroup,
        bottleneckSensor,
        lineInfo
    ]);
    (0,react.useEffect)(function() {
        if (bottleneckSensor && !nodes.find(function(node) {
            return node.peripheralId === bottleneckSensor.peripheralId;
        })) {
            var newGraphNode = {
                sensorName: bottleneckSensor.name,
                sensorDescription: bottleneckSensor.description,
                peripheralId: bottleneckSensor.peripheralId,
                nodeType: schema/* NodeType.Main */.Jq.Main,
                sensorType: bottleneckSensor.config.type,
                registerStops: true,
                oee: true
            };
            setNodes((0,_to_consumable_array/* default */.Z)(nodes).concat([
                newGraphNode
            ]));
        }
    }, [
        bottleneckSensor
    ]);
    var resetState = function() {
        setSensorGroup(null);
        setBottleneckSensor(null);
        setNodes([]);
        setLinks([]);
        setLineInfo({
            name: "",
            description: ""
        });
        setNextButtonDisabled(true);
    };
    var handleBack = function() {
        if (activeStep === 0) {
            return;
        }
        setActiveStep(activeStep - 1);
    };
    var handleClose = function() {
        setActiveStep(0);
        handleOpenClose(false);
    };
    var handleNext = function() {
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(activeStep === steps.length - 2)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            submitFinishedLine()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setActiveStep(activeStep + 1);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var submitFinishedLine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!sensorGroup) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createLine({
                                refetchQueries: [
                                    {
                                        query: (sensor_groups_default())
                                    }
                                ],
                                variables: {
                                    groupId: sensorGroup.id,
                                    name: lineInfo.name,
                                    description: (lineInfo === null || lineInfo === void 0 ? void 0 : lineInfo.description) || "",
                                    nodes: nodes.map(function(node) {
                                        return {
                                            peripheralId: node.peripheralId,
                                            type: node.nodeType
                                        };
                                    }),
                                    edges: links.map(function(link) {
                                        return {
                                            from: link.source,
                                            to: link.target
                                        };
                                    })
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        setActiveStep(activeStep + 1);
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFinishedLine() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderActionButtons = function() {
        var backButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: handleBack,
            className: classes.backButton,
            children: t([
                "shared:back"
            ], {
                defaultValue: "Back"
            })
        });
        var nextButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            disabled: nextButtonDisabled,
            color: "primary",
            onClick: handleNext(),
            children: t([
                "shared:next"
            ], {
                defaultValue: "Next"
            })
        });
        var finishButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            color: "primary",
            onClick: handleNext(),
            children: t([
                "shared:finish"
            ], {
                defaultValue: "Finish"
            })
        });
        switch(activeStep){
            case 0:
                return nextButton;
            case 1:
                return [
                    backButton,
                    nextButton
                ];
            case 2:
                return [
                    backButton,
                    finishButton
                ];
            case 3:
                return null;
            default:
                console.error("Unknown step index!");
        }
    };
    var sensorTypeToNodeType = function(sensorType) {
        if (!sensorType) {
            return schema/* NodeType.Counter */.Jq.Counter;
        }
        switch(sensorType){
            case schema/* SensorType.COUNTER */.dE.COUNTER:
            case schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE:
            case schema/* SensorType.COUNTER_SPEED */.dE.COUNTER_SPEED:
            case schema/* SensorType.DISCRETE */.dE.DISCRETE:
            case schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS:
            case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
                return schema/* NodeType.Counter */.Jq.Counter;
            case schema/* SensorType.EVENT */.dE.EVENT:
                return schema/* NodeType.Event */.Jq.Event;
            default:
                console.warn("Unrecognized sensor type!");
                return schema/* NodeType.Counter */.Jq.Counter;
        }
    };
    var onSelectSensorWithLineSettings = function(sensor) {
        var isCamera = sensor.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA;
        var existingSensorNode = nodes.find(function(node) {
            return node.peripheralId === sensor.peripheralId;
        });
        var id = existingSensorNode === null || existingSensorNode === void 0 ? void 0 : existingSensorNode.peripheralId;
        if (existingSensorNode && existingSensorNode.nodeType !== schema/* NodeType.Main */.Jq.Main) {
            var updatedNodes = nodes.filter(function(node) {
                return node.peripheralId !== id;
            });
            var updatedLinks = links.filter(function(link) {
                return link.source !== id && link.target !== id;
            });
            setNodes(updatedNodes);
            setLinks(updatedLinks);
        } else if (!nodes.some(function(node) {
            return node.peripheralId === sensor.peripheralId;
        })) {
            var newGraphNode = {
                sensorName: sensor.name,
                sensorDescription: sensor.description,
                peripheralId: sensor.peripheralId,
                sensorType: sensor.config.type,
                nodeType: isCamera ? schema/* NodeType.Camera */.Jq.Camera : sensorTypeToNodeType(sensor.config.type),
                registerStops: false,
                oee: false
            };
            setNodes((0,_to_consumable_array/* default */.Z)(nodes).concat([
                newGraphNode
            ]));
        }
    };
    var onAddSensorNode = function(peripheralId, isBeforeMain) {
        var updatedLinks = (0,_to_consumable_array/* default */.Z)(links);
        var source = isBeforeMain ? peripheralId : bottleneckSensor.peripheralId;
        var target = isBeforeMain ? bottleneckSensor.peripheralId : peripheralId;
        updatedLinks.push({
            source: source,
            target: target
        });
        setLinks(updatedLinks);
    };
    var onRemoveSensorNode = function(peripheralId) {
        var updatedLinks = links.filter(function(link) {
            return link.source !== peripheralId && link.target !== peripheralId;
        });
        setLinks(updatedLinks);
    };
    var onSelectBottleneckSensor = function(sensor) {
        var matchingNode = nodes.find(function(node) {
            return node.peripheralId === (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId);
        });
        if (matchingNode) {
            var filteredNodes = (0,_to_consumable_array/* default */.Z)(nodes.filter(function(node) {
                return node.peripheralId !== matchingNode.peripheralId;
            }));
            setNodes(filteredNodes);
        }
        setBottleneckSensor(sensor);
    };
    var getStepContent = function() {
        switch(activeStep){
            case 0:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor_group, {
                    selectedGroup: sensorGroup,
                    onSelectSensorGroup: setSensorGroup
                });
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    alignItems: "stretch",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specify_line_info/* default */.Z, {
                                lineInfo: lineInfo,
                                onChangeLineInfo: setLineInfo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                                title: t([
                                    "line:selectBottleneckCounter"
                                ], {
                                    defaultValue: "Select the bottleneck sensor of the line"
                                }) + "*",
                                disabledSensorId: undefined,
                                sensors: ((sensorGroup === null || sensorGroup === void 0 ? void 0 : sensorGroup.availableSensors) || []).filter(helper_types/* isTruthy */.f),
                                selectedSensorIds: bottleneckSensor ? [
                                    bottleneckSensor.peripheralId
                                ] : [],
                                onSelectSensor: onSelectBottleneckSensor,
                                selectDefault: true
                            })
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t([
                                "line:addRemainingSensors"
                            ], {
                                defaultValue: "To get complete overview of your line, please add any remaining sensors"
                            })
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                            disabledSensorId: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId,
                            title: t([
                                "line:selectOtherSensors"
                            ], {
                                defaultValue: "Select all additional sensors on line"
                            }) + " " + lineInfo.name,
                            selectedSensorIds: nodes.map(function(node) {
                                return node.peripheralId;
                            }),
                            sensors: ((sensorGroup === null || sensorGroup === void 0 ? void 0 : sensorGroup.availableSensors) || []).filter(helper_types/* isTruthy */.f),
                            onSelectSensor: onSelectSensorWithLineSettings
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(line_list_topology/* default */.Z, {
                            // Only non-bottleneck and counter sensors can be scrap
                            availableNodes: nodes.filter(function(node) {
                                return node.nodeType !== schema/* NodeType.Main */.Jq.Main && (node.sensorType === schema/* SensorType.COUNTER */.dE.COUNTER || node.sensorType === schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE);
                            }),
                            mainSensorNodeName: bottleneckSensor.name,
                            mainSensorNodePeripheralId: bottleneckSensor.peripheralId,
                            nodeLinks: links,
                            onAddScrapSensor: onAddSensorNode,
                            onRemoveScrapSensor: onRemoveSensorNode
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sx: {
                            textAlign: "center",
                            maxWidth: "500px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: t([
                                "line:creationDelayExplanation"
                            ], {
                                defaultValue: "It might take up to 5 minutes for the line to appear in the Lines Overview. Try refreshing the page after closing this dialog."
                            })
                        })
                    })
                });
            default:
                return "Unknown stepIndex";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        maxWidth: false,
        open: open,
        onClose: handleClose,
        PaperProps: {
            className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.dialogSize),
            style: {
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: steps[activeStep],
                onClose: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
                activeStep: activeStep,
                alternativeLabel: true,
                className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.stepper),
                children: steps.map(function(label, i) {
                    if (i === steps.length - 1) {
                        // We deliberately don't want to show the finish page as a step.
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step/* default */.Z, {
                        className: classes.step,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabel/* default */.Z, {
                            children: label
                        })
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.stepContent),
                children: getStepContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                className: classes.dialogBackgroundColor,
                children: renderActionButtons()
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay_spinner/* default */.Z, {}) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
// EXTERNAL MODULE: ./graphql/queries/lines-list-simple.gql
var lines_list_simple = __webpack_require__(16450);
var lines_list_simple_default = /*#__PURE__*/__webpack_require__.n(lines_list_simple);
// EXTERNAL MODULE: ./hocs/with-line.tsx
var with_line = __webpack_require__(41440);
// EXTERNAL MODULE: ./hocs/with-iam.tsx
var with_iam = __webpack_require__(98156);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(74782);
// EXTERNAL MODULE: ./graphql/queries/line-overview-with-kpi.gql
var line_overview_with_kpi = __webpack_require__(92126);
var line_overview_with_kpi_default = /*#__PURE__*/__webpack_require__.n(line_overview_with_kpi);
// EXTERNAL MODULE: ./helpers/schedule.ts
var schedule = __webpack_require__(40510);
// EXTERNAL MODULE: ./lib/hash.ts
var hash = __webpack_require__(34614);
// EXTERNAL MODULE: ./types/index.ts
var types = __webpack_require__(24877);
// EXTERNAL MODULE: ./types/auth-types.ts
var auth_types = __webpack_require__(44178);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(6435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Build.js
var Build = __webpack_require__(55063);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(81401);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(16438);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(85466);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34907);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/link.js
var next_link = __webpack_require__(398);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/containers/highcharts.tsx
var highcharts = __webpack_require__(75805);
// EXTERNAL MODULE: ./components/icons/signal-avatar.tsx
var signal_avatar = __webpack_require__(50524);
// EXTERNAL MODULE: ./lib/get-line-status.ts
var get_line_status = __webpack_require__(27703);
// EXTERNAL MODULE: ./lib/highcharts/manual-process-config.ts
var manual_process_config = __webpack_require__(80946);
// EXTERNAL MODULE: ./helpers/helper-functions.ts
var helper_functions = __webpack_require__(15608);
// EXTERNAL MODULE: ./helpers/highcharts.ts
var helpers_highcharts = __webpack_require__(75743);
// EXTERNAL MODULE: ./lib/highcharts/filters.ts
var filters = __webpack_require__(51169);
// EXTERNAL MODULE: ./lib/highcharts/config-helpers.ts
var config_helpers = __webpack_require__(84521);
// EXTERNAL MODULE: ./lib/highcharts/data-config.ts + 2 modules
var data_config = __webpack_require__(8411);
;// CONCATENATED MODULE: ./lib/highcharts/overview-config.ts







var getConfig = function(param) {
    var t = param.t, height = param.height, sensor = param.sensor, _disableAxisLabel = param.disableAxisLabel, disableAxisLabel = _disableAxisLabel === void 0 ? false : _disableAxisLabel, theme = param.theme, showStops = param.showStops, showStopLabels = param.showStopLabels, language = param.language;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14;
    var type = (ref14 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.config) === null || ref === void 0 ? void 0 : ref.type) !== null && ref14 !== void 0 ? ref14 : schema/* SensorType.COUNTER */.dE.COUNTER;
    var isMeasurement = type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT;
    var ref15;
    // Set a default label on the y-axis.
    var chartTimeScale = (ref15 = sensor === null || sensor === void 0 ? void 0 : (ref1 = sensor.config) === null || ref1 === void 0 ? void 0 : ref1.chartTimeScale) !== null && ref15 !== void 0 ? ref15 : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    var ref16 = (0,_sliced_to_array/* default */.Z)(disableAxisLabel ? [
        ,
        ""
    ] : (0,helpers_highcharts/* determineLabel */.t)(t, sensor), 2), yAxisLabel = ref16[1];
    var stops = showStops ? sensor === null || sensor === void 0 ? void 0 : (ref2 = sensor.time) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.stops : [];
    var index = 0;
    var ref17;
    // NOTE: The cast here is to workaround __typename - omit recursively fails as well :(
    var querySamples = ((ref17 = sensor === null || sensor === void 0 ? void 0 : (ref4 = sensor.time) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.samples) !== null && ref17 !== void 0 ? ref17 : []).filter(function(sample) {
        return !!sample.timeRange.from && !!sample.timeRange.to;
    });
    var sensorIndex = (sensor === null || sensor === void 0 ? void 0 : sensor.colorIndex) || index;
    var color = isMeasurement ? data_config/* MEASUREMENT_CHART_COLORS */.bW[sensorIndex % data_config/* MEASUREMENT_CHART_COLORS.length */.bW.length] : data_config/* CHART_COLORS */.ZE[sensorIndex % data_config/* CHART_COLORS.length */.ZE.length];
    var now = Date.now();
    var scale = function() {
        if (isMeasurement) {
            return 0;
        }
        switch(chartTimeScale){
            case schema/* ChartTimeScale.DAY */.cW.DAY:
                return 1..days;
            case schema/* ChartTimeScale.HOUR */.cW.HOUR:
                return 1..hours;
            case schema/* ChartTimeScale.MINUTE */.cW.MINUTE:
                return 1..minutes;
            default:
                return 0;
        }
    }();
    var speedProcessor = (sensor === null || sensor === void 0 ? void 0 : (ref6 = sensor.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.chart) === null || ref7 === void 0 ? void 0 : ref7.dataFilter) || schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED;
    var processor = scale ? speedProcessor : schema/* DataFilter.NONE */.Zv.NONE;
    var sampleProcessor = config_helpers/* pointProcessors */.LB[processor];
    var voidProcessor = config_helpers/* pointProcessors.VOID */.LB.VOID;
    var varianceProcessor = config_helpers/* pointProcessors.VARIANCE */.LB.VARIANCE;
    var isUptime = processor === schema/* DataFilter.UPTIME */.Zv.UPTIME;
    // NOTE: Points are always evenly distributed from the API
    var _querySamples = (0,_sliced_to_array/* default */.Z)(querySamples, 1), firstSample = _querySamples[0];
    var perPointSpan = firstSample ? new Date(firstSample.timeRange.to).getTime() - new Date(firstSample.timeRange.from).getTime() : Infinity;
    var composers = [
        voidProcessor({
            average: isMeasurement,
            now: now
        }),
        sampleProcessor({
            scale: scale,
            average: isMeasurement,
            perPointSpan: perPointSpan
        }),
        varianceProcessor({
            isMeasurement: isMeasurement
        }), 
    ];
    // FIXME: Once TypeScript gets smart enough with detecting tuple length
    // move the cast to the type argument of reduce.
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,config_helpers/* pipePoints */.n3)(querySamples, composers), 3), voidData = ref18[0], samples = ref18[1], variances = ref18[2];
    var filteredSamples = [
        schema/* DataFilter.NONE */.Zv.NONE,
        schema/* DataFilter.UPTIME */.Zv.UPTIME
    ].every(function(filter) {
        return processor !== filter;
    }) ? (0,filters/* memoizedFiltering */.Nl)(samples, config_helpers/* dataFilters */.ay, {
        peripheralId: sensor === null || sensor === void 0 ? void 0 : sensor.peripheralId
    }) : samples;
    var ref19, ref20, ref21, ref22;
    var plotConfig = {
        exporting: {
            enabled: false
        },
        chart: {
            resetZoomButton: {
                theme: {
                    display: "none"
                }
            },
            height: height
        },
        series: [
            {
                // @ts-ignore
                boostThreshold: 1,
                animation: false,
                type: "line",
                id: "obj.name",
                name: "",
                data: filteredSamples,
                color: color.color,
                showInLegend: false,
                tooltip: {
                    // @ts-ignore
                    enabled: false
                },
                marker: {
                    enabled: false
                },
                shared: false
            },
            // serie 1, variance graph used with analog
            {
                // @ts-ignore
                animation: false,
                type: "arearange",
                name: "Variance",
                data: variances,
                color: color.variance,
                lineWidth: 0,
                fillOpacity: 0.3,
                linkedTo: ":previous",
                tooltip: {
                    // @ts-ignore
                    enabled: false
                },
                zIndex: 0,
                marker: {
                    enabled: false
                },
                visible: type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT
            },
            // serie 2, missing data graph
            {
                // @ts-ignore
                animation: false,
                type: "line",
                name: "Missing data",
                data: voidData,
                dashStyle: "Dot",
                tooltip: {
                    // @ts-ignore
                    enabled: false
                },
                marker: {
                    enabled: false
                },
                showInLegend: false,
                color: "red",
                lineWidth: 2
            }, 
        ],
        credits: {
            enabled: false
        },
        legend: {
            enabled: true
        },
        xAxis: [
            {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).millisecond,
                    second: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).second,
                    minute: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).minute,
                    hour: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).hour,
                    day: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).day,
                    week: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).week,
                    month: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).month,
                    year: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).year
                },
                title: {
                    text: disableAxisLabel ? " " : t([
                        "shared:date"
                    ], {
                        defaultValue: "Date"
                    })
                },
                plotBands: ((ref19 = sensor === null || sensor === void 0 ? void 0 : sensor.time) !== null && ref19 !== void 0 ? ref19 : []).length ? (0,config_helpers/* getBatchAndStopsPlotBands */.i0)((ref20 = sensor === null || sensor === void 0 ? void 0 : (ref8 = sensor.time) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.batches) === null || ref10 === void 0 ? void 0 : ref10.items) !== null && ref20 !== void 0 ? ref20 : [], stops, null, theme, showStopLabels) : undefined
            }, 
        ],
        yAxis: {
            min: ((ref21 = sensor === null || sensor === void 0 ? void 0 : (ref11 = sensor.config) === null || ref11 === void 0 ? void 0 : ref11.type) !== null && ref21 !== void 0 ? ref21 : schema/* SensorType.COUNTER */.dE.COUNTER) === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT ? undefined : 0,
            max: ((ref22 = sensor === null || sensor === void 0 ? void 0 : (ref12 = sensor.time) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.samples) !== null && ref22 !== void 0 ? ref22 : []).every(function(p) {
                return p.data.accValue === 0 || p.data.accValue === null;
            }) ? 10 : undefined,
            maxPadding: 0.05,
            minRange: 0.01,
            tickInterval: isUptime ? 1 : undefined,
            endOnTick: false,
            title: {
                text: yAxisLabel
            }
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: false,
                        animation: false
                    }
                }
            },
            area: {
                marker: {
                    radius: 2,
                    enabled: false
                },
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null
            }
        }
    };
    return plotConfig;
};
/* harmony default export */ var overview_config = (getConfig);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(72748);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/OpenInBrowser.js
var OpenInBrowser = __webpack_require__(3319);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/SettingsSharp.js
var SettingsSharp = __webpack_require__(96487);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mdi-material-ui@7.7.0_@mui+material@5.12.0_react@17.0.2/node_modules/mdi-material-ui/Pin.js
var Pin = __webpack_require__(57193);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mdi-material-ui@7.7.0_@mui+material@5.12.0_react@17.0.2/node_modules/mdi-material-ui/PinOff.js
var PinOff = __webpack_require__(9664);
;// CONCATENATED MODULE: ./components/pin-item.tsx













var pin_item_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
});
var PinItem = function(param) {
    var identifier = param.identifier, storage = param.storage;
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useLocalStorage */._)([
        constants/* LOCAL_STORAGE_PINNED */.dV,
        storage
    ].join("_"), []), 2), pinnedItems = ref[0], setPinnedItems = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref1[0];
    var classes = pin_item_useStyles().classes;
    var isPinned = pinnedItems.includes(identifier);
    var onClick = (0,react.useCallback)(function(event) {
        event.preventDefault();
        if (isPinned) {
            setPinnedItems(pinnedItems.filter(function(id) {
                return id !== identifier;
            }));
        } else {
            setPinnedItems((0,_to_consumable_array/* default */.Z)(pinnedItems).concat([
                identifier
            ]));
        }
    }, [
        isPinned,
        pinnedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
        onClick: onClick,
        className: classes.menuItemStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                className: classes.menuItemIcon,
                children: isPinned ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PinOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "inherit",
                noWrap: true,
                children: isPinned ? t([
                    "shared:unpin"
                ], {
                    defaultValue: "Unpin"
                }) : t([
                    "shared:pin"
                ], {
                    defaultValue: "Pin"
                })
            })
        ]
    });
};
/* harmony default export */ var pin_item = (PinItem);

// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(59721);
;// CONCATENATED MODULE: ./views/lines/line-card-menu.tsx

















var line_card_menu_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            flex: "0 0 auto",
            "@media print": {
                display: "none"
            }
        },
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
});
var LineOverviewCardMenu = function(param) {
    var lineId = param.lineId, openDialog = param.openDialog, mainSensor = param.mainSensor;
    var ref, ref1;
    var classes = line_card_menu_useStyles().classes;
    var hasFeatureInAnyGroup = (0,use_iam/* useIAM */.e)().hasFeatureInAnyGroup;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)([
        "shared",
        "line"
    ]), 1), t = ref2[0];
    var buttons = (0,react.useMemo)(function() {
        return [
            {
                label: t([
                    "shared:registerStops"
                ], {
                    defaultValue: "Register Stops"
                }),
                uri: "register-stops"
            },
            {
                label: t([
                    "shared:batches"
                ], {
                    defaultValue: "Batches"
                }).titleCase,
                uri: "batches"
            },
            {
                label: t([
                    "shared:analytics"
                ], {
                    defaultValue: "Analytics"
                }),
                uri: "analytics"
            },
            {
                label: t([
                    "shared:oee"
                ], {
                    defaultValue: "OEE"
                }),
                uri: "oee"
            },
            {
                label: t([
                    "shared:trends"
                ], {
                    defaultValue: "Trends"
                }),
                uri: "trends"
            }, 
        ];
    }, [
        t
    ]);
    var ref3 = (0,react.useState)(null), menuAnchor = ref3[0], setMenuAnchor = ref3[1];
    var clearMenuAnchor = (0,react.useCallback)(function() {
        return setMenuAnchor(null);
    }, []);
    var handleMenuClick = (0,react.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        clearMenuAnchor();
        openDialog();
    }, []);
    var handleMenuClose = (0,react.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        clearMenuAnchor();
    }, []);
    var onLineSettingsClick = (0,react.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        clearMenuAnchor();
    }, []);
    var onMenuItemClick = (0,react.useCallback)(function() {
        return setMenuAnchor(null);
    }, []);
    var ref4;
    var mainSensorUnitLabel = (ref4 = mainSensor === null || mainSensor === void 0 ? void 0 : (ref = mainSensor.config) === null || ref === void 0 ? void 0 : (ref1 = ref.sensorUnit) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref4 !== void 0 ? ref4 : "";
    var openMenu = Boolean(menuAnchor);
    var canEditLines = hasFeatureInAnyGroup([
        "Lines.Line"
    ], "M");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "More",
                "aria-owns": openMenu ? "long-menu" : undefined,
                "aria-haspopup": "true",
                onClick: handleMenuClick,
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                id: "long-menu",
                anchorEl: menuAnchor,
                open: openMenu,
                onClose: handleMenuClose,
                PaperProps: {
                    style: {}
                },
                children: [
                    buttons.map(function(btn) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                            href: {
                                pathname: "/line",
                                query: {
                                    lineId: lineId,
                                    tab: btn.uri
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                selected: false,
                                onClick: onMenuItemClick,
                                className: classes.menuItemStyles,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "inherit",
                                    noWrap: true,
                                    children: btn.label
                                })
                            }, "".concat(btn.uri, "-Menu"))
                        }, btn.uri);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        variant: "middle"
                    }),
                    !canEditLines ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        selected: false,
                        onClick: onLineSettingsClick,
                        className: classes.menuItemStyles,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                className: classes.menuItemIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "inherit",
                                noWrap: true,
                                children: t([
                                    "line:lineSettings"
                                ], {
                                    defaultValue: "Line settings"
                                })
                            })
                        ]
                    }, "lineSettingsMenu"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                        href: {
                            pathname: "/line",
                            query: {
                                lineId: lineId,
                                tab: "schedule"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            selected: false,
                            onClick: onMenuItemClick,
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    className: classes.menuItemIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(constants/* SCHEDULE_ICON */.Pu, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "inherit",
                                    noWrap: true,
                                    children: t([
                                        "shared:schedule"
                                    ], {
                                        defaultValue: "Schedule"
                                    })
                                })
                            ]
                        }, "lineScheduleMenu")
                    }, "lineSchedule"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                        href: {
                            pathname: "/dashboard/batch",
                            query: {
                                lineId: lineId,
                                layout: "compact"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            selected: false,
                            onClick: onMenuItemClick,
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    className: classes.menuItemIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "inherit",
                                    noWrap: true,
                                    children: t([
                                        "shared:batchDashboard"
                                    ], {
                                        defaultValue: "Batch Dashboard"
                                    })
                                })
                            ]
                        }, "batchDashboardMenu")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                        href: {
                            pathname: "/dashboard/shift",
                            query: {
                                lineId: lineId,
                                layout: "compact",
                                mainSensorUnitLabel: mainSensorUnitLabel
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            selected: false,
                            onClick: onMenuItemClick,
                            className: classes.menuItemStyles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    className: classes.menuItemIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "inherit",
                                    noWrap: true,
                                    children: t([
                                        "shared:shiftDashboard"
                                    ], {
                                        defaultValue: "Shift Dashboard"
                                    })
                                })
                            ]
                        }, "shiftDashboardMenu")
                    }, "shiftDashboard"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        variant: "middle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pin_item, {
                        identifier: lineId,
                        storage: "LINES"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var line_card_menu = (LineOverviewCardMenu);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/green.js
var green = __webpack_require__(21955);
// EXTERNAL MODULE: ./components/card-box.tsx
var card_box = __webpack_require__(7907);
// EXTERNAL MODULE: ./components/line-status.tsx
var line_status = __webpack_require__(92707);
// EXTERNAL MODULE: ./components/progress-meter.tsx
var progress_meter = __webpack_require__(23387);
// EXTERNAL MODULE: ./hocs/with-utils.tsx
var with_utils = __webpack_require__(81861);
// EXTERNAL MODULE: ./views/tabs/oee/oee-kpi-card.tsx + 1 modules
var oee_kpi_card = __webpack_require__(70912);
;// CONCATENATED MODULE: ./views/lines/overview-components/oee.tsx










var oee_styles = function(theme) {
    return {
        card: {
            width: "100%",
            minHeight: "70px"
        },
        loadingCardContent: {
            height: "200px"
        },
        flexContainer: {
            display: "flex"
        },
        includeScrapButton: {
            marginLeft: theme.spacing(2)
        }
    };
};
var Oee = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Oee, _Component);
    var _super = (0,_create_super/* default */.Z)(Oee);
    function Oee(props) {
        (0,_class_call_check/* default */.Z)(this, Oee);
        return _super.call(this, props);
    }
    var _proto = Oee.prototype;
    _proto.render = function render() {
        var theme = this.props.theme;
        var ref = this.props.oee || {}, _oee1 = ref.oee1, oee1 = _oee1 === void 0 ? 0 : _oee1, _oee2 = ref.oee2, oee2 = _oee2 === void 0 ? 0 : _oee2, _oee3 = ref.oee3, oee3 = _oee3 === void 0 ? 0 : _oee3, _tcu = ref.tcu, tcu = _tcu === void 0 ? 0 : _tcu;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 1,
            alignItems: "stretch",
            justifyContent: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                    gaugeColor: theme.blackbird.stops.NO_ACT.color.normal,
                    title: "TCU",
                    value: tcu,
                    size: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                    gaugeColor: theme.blackbird.stops.NON_PROD.color.normal,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "OEE",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                children: "3"
                            })
                        ]
                    }),
                    value: oee3,
                    size: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                    gaugeColor: theme.blackbird.stops.BATCH_NON_PROD.color.normal,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "OEE",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                children: "2"
                            })
                        ]
                    }),
                    value: oee2,
                    size: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                    gaugeColor: theme.blackbird.stops.DOWNTIME.color.normal,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "OEE",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                children: "1"
                            })
                        ]
                    }),
                    value: oee1,
                    size: "small"
                })
            ]
        });
    };
    return Oee;
}(react.Component);
var oee_enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(oee_styles, {
    withTheme: true
}));
/* harmony default export */ var overview_components_oee = (oee_enhance(Oee));

// EXTERNAL MODULE: ./graphql/queries/andon-list-unresolved-calls-for-line.gql
var andon_list_unresolved_calls_for_line = __webpack_require__(95540);
var andon_list_unresolved_calls_for_line_default = /*#__PURE__*/__webpack_require__.n(andon_list_unresolved_calls_for_line);
;// CONCATENATED MODULE: ./views/lines/overview-components/unresolved-andon-calls.tsx














var unresolved_andon_calls_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        background: {
            backgroundColor: "".concat(theme.palette.error.main, " !important"),
            color: theme.palette.getContrastText(theme.palette.error.main)
        }
    };
});
var UnresolvedAndonCalls = function(param) {
    var lineId = param.lineId;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* useLocalStorage */._)(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ, defaultCardConf), 1), cardConf = ref3[0];
    var ref4 = (0,client.useQuery)((andon_list_unresolved_calls_for_line_default()), {
        ssr: false,
        partialRefetch: true,
        pollInterval: 5..minutes,
        variables: {
            lineId: lineId
        }
    }), data = ref4.data, loading = ref4.loading;
    var ref5;
    var calls = (ref5 = data === null || data === void 0 ? void 0 : (ref = data.andon) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.calls) !== null && ref5 !== void 0 ? ref5 : [];
    var count = loading ? t([
        "shared:notAvailable"
    ], {
        defaultValue: "N/A"
    }) : calls.length;
    var ref6 = unresolved_andon_calls_useStyles(), classes = ref6.classes, cx = ref6.cx;
    if (!cardConf.unresolvedAndonCalls) {
        return null;
    }
    // FIXME: react-i18next strikes again with their bad type inference - the cast
    // to any shouldn't be necessary, but it is.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_box/* default */.Z, {
            small: true,
            className: cx((0,_define_property/* default */.Z)({}, classes.background, !!calls.length)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: t("andon:unresolvedAndonCalls", {
                        defaultValue: "Unresolved Andon calls: {{count}}",
                        count: count
                    })
                }),
                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                    variant: "indeterminate"
                }) : null
            ]
        })
    });
};
/* harmony default export */ var unresolved_andon_calls = (UnresolvedAndonCalls);

;// CONCATENATED MODULE: ./views/lines/overview-components/components.tsx






















var components_styles = function(theme) {
    return {
        gridPad: {
            padding: "0px 16px",
            marginBottom: 8,
            alignItems: "center"
        },
        oeeGridPad: {
            marginTop: "-7px",
            marginBottom: 0
        },
        greenButton: {
            backgroundColor: green/* default.600 */.Z[600],
            color: theme.palette.getContrastText(green/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: green/* default.600 */.Z[600]
            }
        },
        redButton: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        small: {
            height: "2em",
            width: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
};
var LineOverviewInfo = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LineOverviewInfo, _Component);
    var _super = (0,_create_super/* default */.Z)(LineOverviewInfo);
    function LineOverviewInfo() {
        (0,_class_call_check/* default */.Z)(this, LineOverviewInfo);
        return _super.apply(this, arguments);
    }
    var _proto = LineOverviewInfo.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
        var _props = this.props, conf = _props.conf, classes = _props.classes, t = _props.t, line = _props.line, lineStatus = _props.lineStatus, utils = _props.utils;
        var sensorType = line === null || line === void 0 ? void 0 : (ref = line.mainSensor) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.type;
        var batches = (line === null || line === void 0 ? void 0 : (ref2 = line.mainSensor) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.time) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.batches) === null || ref5 === void 0 ? void 0 : ref5.items) || [];
        var batchData = batches.reduce(function(agg, item) {
            if (!agg) {
                return item;
            }
            if (!item || agg.actualStart && item.actualStart && new Date(agg.actualStart).getTime() > new Date(item === null || item === void 0 ? void 0 : item.actualStart).getTime()) {
                return agg;
            } else {
                return item;
            }
        }, null);
        var ref29;
        var batchProduced = Math.floor((ref29 = batchData === null || batchData === void 0 ? void 0 : (ref6 = batchData.stats) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.produced) !== null && ref29 !== void 0 ? ref29 : 0);
        var ref30;
        var product = (ref30 = batchData === null || batchData === void 0 ? void 0 : (ref8 = batchData.product) === null || ref8 === void 0 ? void 0 : ref8.name) !== null && ref30 !== void 0 ? ref30 : t([
            "shared:notAvailable"
        ], {
            defaultValue: "N/A"
        }) || "";
        var ref31;
        var productNumber = (ref31 = batchData === null || batchData === void 0 ? void 0 : (ref9 = batchData.product) === null || ref9 === void 0 ? void 0 : ref9.itemNumber) !== null && ref31 !== void 0 ? ref31 : t([
            "shared:notAvailable"
        ], {
            defaultValue: "N/A"
        });
        var ref32;
        var completePercentageBatch = batchData ? Math.floor(batchProduced / ((ref32 = batchData === null || batchData === void 0 ? void 0 : batchData.amount) !== null && ref32 !== void 0 ? ref32 : NaN) * 100) : 0;
        var ref33;
        var etc = new Date(new Date(Date.now()).getTime() + Math.max(((ref33 = batchData === null || batchData === void 0 ? void 0 : batchData.amount) !== null && ref33 !== void 0 ? ref33 : 0) - batchProduced, 0) / ((batchData === null || batchData === void 0 ? void 0 : (ref10 = batchData.product) === null || ref10 === void 0 ? void 0 : ref10.expectedAverageSpeed) || 1) * 1..minutes);
        var ref34;
        var weeklyTarget = (ref34 = line === null || line === void 0 ? void 0 : (ref11 = line.schedule) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.weeklyTargets) === null || ref12 === void 0 ? void 0 : ref12.produced) !== null && ref34 !== void 0 ? ref34 : Infinity;
        var producedPastWeek = ((ref13 = line.pastWeekTime) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.stats) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : ref16.produced) || 0;
        var producedPastDay = ((ref17 = line.pastDayTime) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.stats) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.data) === null || ref20 === void 0 ? void 0 : ref20.produced) || 0;
        var completePercentageWeek = Math.floor(producedPastWeek / weeklyTarget * 100);
        var ref35;
        var batchNumber = (ref35 = batchData === null || batchData === void 0 ? void 0 : batchData.batchNumber) !== null && ref35 !== void 0 ? ref35 : t([
            "shared:notAvailable"
        ], {
            defaultValue: "N/A"
        });
        var ref36;
        var unregisteredStops = ((ref36 = line === null || line === void 0 ? void 0 : (ref21 = line.mainSensor) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.time) === null || ref22 === void 0 ? void 0 : (ref23 = ref22[0]) === null || ref23 === void 0 ? void 0 : ref23.stops) !== null && ref36 !== void 0 ? ref36 : []).filter(function(stop) {
            return (stop === null || stop === void 0 ? void 0 : stop.registeredTime) === null;
        });
        var oee = (line === null || line === void 0 ? void 0 : (ref24 = line.mainSensor) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.time) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.stats) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.data) === null || ref28 === void 0 ? void 0 : ref28.oee) || null;
        var betterETC;
        if (!batchData) {
            betterETC = t([
                "shared:notAvailable"
            ], {
                defaultValue: "N/A"
            });
        } else if ((batchData === null || batchData === void 0 ? void 0 : batchData.state) === schema/* BatchState.COMPLETED */.AM.COMPLETED) {
            betterETC = t([
                "batches:completed"
            ], {
                defaultValue: "Completed"
            });
        } else if (etc.getTime() <= Date.now()) {
            betterETC = t([
                "batches:completed"
            ], {
                defaultValue: "Completed"
            });
        } else {
            betterETC = utils.formatByString(etc, "dd MMMM, HH:mm");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 1,
            children: [
                conf.showBatchProgress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_meter/* default */.Z, {
                        inlineTitle: t([
                            "batches:progress"
                        ], {
                            defaultValue: "Batch progress"
                        }),
                        completePercentage: completePercentageBatch,
                        left: (batchData === null || batchData === void 0 ? void 0 : batchData.amount) ? batchProduced : "",
                        right: (batchData === null || batchData === void 0 ? void 0 : batchData.amount) || t([
                            "shared:notAvailable"
                        ], {
                            defaultValue: "N/A"
                        }),
                        small: true
                    })
                }) : null,
                conf.showBatchProgressPercentage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_meter/* default */.Z, {
                        inlineTitle: t([
                            "batches:progress"
                        ], {
                            defaultValue: "Batch progress"
                        }),
                        completePercentage: completePercentageBatch,
                        left: (batchData === null || batchData === void 0 ? void 0 : batchData.amount) ? "".concat(completePercentageBatch, "%") : "",
                        right: (batchData === null || batchData === void 0 ? void 0 : batchData.amount) ? "100%" : t([
                            "shared:notAvailable"
                        ], {
                            defaultValue: "N/A"
                        }),
                        small: true
                    })
                }) : null,
                conf.showWeeklyProgress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_meter/* default */.Z, {
                        inlineTitle: t([
                            "batches:producedWeek"
                        ], {
                            defaultValue: "Produced this week"
                        }),
                        completePercentage: completePercentageWeek,
                        left: producedPastWeek.toLocaleString(),
                        right: Number.isFinite(weeklyTarget) ? weeklyTarget.toLocaleString() : t([
                            "shared:notAvailable"
                        ], {
                            defaultValue: "N/A"
                        }),
                        small: true
                    })
                }) : null,
                conf.showDailyProgress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_box/* default */.Z, {
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: "".concat(t([
                                    "shared:producedSinceYesterday"
                                ], {
                                    defaultValue: "Produced since yesterday"
                                }), ": ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                noWrap: true,
                                children: producedPastDay
                            })
                        ]
                    })
                }) : null,
                conf.showLineStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_status/* default */.Z, {
                        sensorType: sensorType !== null && sensorType !== void 0 ? sensorType : undefined,
                        lineStatus: lineStatus,
                        small: true
                    })
                }) : null,
                conf.showEstimatedTimeOfCompletion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_box/* default */.Z, {
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: [
                                    "".concat(t([
                                        "batches:etcAbbr"
                                    ], {
                                        defaultValue: "ETC"
                                    }), ": "),
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                noWrap: true,
                                children: betterETC
                            })
                        ]
                    })
                }) : null,
                conf.showBatchNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_box/* default */.Z, {
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: [
                                    "".concat(t([
                                        "shared:batchPONumber"
                                    ], {
                                        defaultValue: "Batch/PO No."
                                    }), ": "),
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                noWrap: true,
                                children: batchNumber
                            })
                        ]
                    })
                }) : null,
                conf.showBatchProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_box/* default */.Z, {
                        small: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                minWidth: 0,
                                padding: "5px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "body2",
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: [
                                        "".concat(t([
                                            "shared:product"
                                        ], {
                                            defaultValue: "Product"
                                        }), ": "),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: product,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        style: {
                                            flex: 1,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: product
                                    })
                                })
                            ]
                        })
                    })
                }) : null,
                conf.showBatchProductNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_box/* default */.Z, {
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: [
                                    "".concat(t([
                                        "shared:productNumber"
                                    ], {
                                        defaultValue: "Product No."
                                    }), ": "),
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                noWrap: true,
                                children: productNumber
                            })
                        ]
                    })
                }) : null,
                conf.countUnregisteredStops ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                        href: {
                            pathname: "/line",
                            query: {
                                lineId: line.id,
                                tab: "register-stops"
                            }
                        },
                        underline: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            color: "primary",
                            variant: "contained",
                            className: (0,clsx_m["default"])(unregisteredStops.length ? classes.redButton : classes.greenButton, classes.small),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "#fff",
                                        textTransform: "none"
                                    },
                                    children: "".concat(t([
                                        "shared:unregisteredStops"
                                    ], {
                                        defaultValue: "Unregistered stops"
                                    }), ":")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "#fff",
                                        padding: "5px",
                                        fontWeight: 500
                                    },
                                    noWrap: true,
                                    children: unregisteredStops.length
                                })
                            ]
                        })
                    }, "register-stops")
                }) : null,
                conf.showOee ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    className: (0,clsx_m["default"])(classes.gridPad, classes.oeeGridPad),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_components_oee, {
                        oee: oee
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unresolved_andon_calls, {
                    lineId: line.id
                })
            ]
        });
    };
    return LineOverviewInfo;
}(react.Component);
var components_enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line",
    "batches"
]), with_utils/* withUtils */.W, (0,with_styles/* withStyles */.D)(components_styles));
/* harmony default export */ var components = (components_enhance(LineOverviewInfo));

;// CONCATENATED MODULE: ./views/lines/line-card.tsx

































var LineSettingsDialog = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(5377), __webpack_require__.e(8253), __webpack_require__.e(7905)]).then(__webpack_require__.bind(__webpack_require__, 50859))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50859)
            ];
        }
    }
});
var line_card_styles = function(theme) {
    return {
        card: {
            height: "100%",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        anchor: {
            textDecoration: "none",
            color: "black"
        },
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing(),
            display: "flex",
            justifyContent: "space-around"
        },
        button: {
            margin: theme.spacing()
        },
        progressContainer: {
            display: "flex",
            justifyContent: "center",
            height: "180px",
            paddingTop: "50px"
        },
        lineIcon: {
            height: 20,
            width: 20,
            marginRight: theme.spacing(),
            marginBottom: theme.spacing(-0.5)
        }
    };
};
var countOverdueTasks = function(line) {
    if (!(line === null || line === void 0 ? void 0 : line.nodes)) {
        return 0;
    }
    return line.nodes.reduce(function(acc, node) {
        var ref, ref1, ref2;
        var ref3;
        var tasks = (ref3 = node === null || node === void 0 ? void 0 : (ref = node.sensor) === null || ref === void 0 ? void 0 : (ref1 = ref.maintenanceWorkOrders) === null || ref1 === void 0 ? void 0 : ref1.nodes) !== null && ref3 !== void 0 ? ref3 : [];
        if (tasks.length === 0) {
            return acc;
        }
        var ref4;
        if (new Date((ref4 = (ref2 = tasks[0]) === null || ref2 === void 0 ? void 0 : ref2.timestamp) !== null && ref4 !== void 0 ? ref4 : 0) < new Date()) {
            // Task is overdue
            return acc + 1;
        }
        return acc;
    }, 0);
};
var LineOverviewCard = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LineOverviewCard, _Component);
    var _super = (0,_create_super/* default */.Z)(LineOverviewCard);
    function LineOverviewCard() {
        (0,_class_call_check/* default */.Z)(this, LineOverviewCard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isHover: false,
            settingsDialogOpen: false,
            dataHash: ""
        };
        _this.handleDialogChange = function(open) {
            return _this.setState({
                settingsDialogOpen: open
            });
        };
        _this.openDialog = function() {
            return _this.setState({
                settingsDialogOpen: true
            });
        };
        return _this;
    }
    var _proto = LineOverviewCard.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.loading !== this.props.loading || nextProps.dataHash !== this.props.dataHash || nextState.dataHash !== this.state.dataHash || nextProps.mainSensorConfigurationError !== this.props.mainSensorConfigurationError || !isEqual_default()(nextProps.conf, this.props.conf)) {
            return true;
        } else if (nextState !== this.state) {
            return true;
        }
        return false;
    };
    // We unset the datahash so that highcharts will rerender when we mount the component again.
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.setState({
            dataHash: ""
        });
    };
    _proto.render = function render() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        var _props = this.props, conf = _props.conf, classes = _props.classes, line = _props.line, t = _props.t, i18n = _props.i18n, refetchQueries = _props.refetchQueries, deleteRefetchQueries = _props.deleteRefetchQueries, theme = _props.theme, mainSensorConfigurationError = _props.mainSensorConfigurationError;
        var _state = this.state, settingsDialogOpen = _state.settingsDialogOpen, dataHash = _state.dataHash;
        var id = line.id, name = line.name, description = line.description;
        var mainSensor = line === null || line === void 0 ? void 0 : line.mainSensor;
        var ref11 = (mainSensor === null || mainSensor === void 0 ? void 0 : (ref = mainSensor.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.stats) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.lineStatus) || {}, status = ref11.status, duration = ref11.duration, cause = ref11.cause;
        var chartLoading = mainSensor ? false : true;
        var ref12;
        var stopRegisterThreshold = (ref12 = mainSensor === null || mainSensor === void 0 ? void 0 : (ref4 = mainSensor.config) === null || ref4 === void 0 ? void 0 : ref4.stopRegisterThreshold) !== null && ref12 !== void 0 ? ref12 : 10..seconds;
        var ref13 = (0,get_line_status/* default */.Z)(t, theme, status, duration !== null && duration !== void 0 ? duration : 0, stopRegisterThreshold, cause !== null && cause !== void 0 ? cause : "Pending"), statusColor = ref13.statusColor, statusText = ref13.statusText, lineDuration = ref13.lineDuration;
        var ref14;
        var strength = ((ref14 = mainSensor === null || mainSensor === void 0 ? void 0 : (ref5 = mainSensor.time) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.stats) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.lineStatus) === null || ref9 === void 0 ? void 0 : ref9.status) !== null && ref14 !== void 0 ? ref14 : schema/* Status.OFF */.qb.OFF) === schema/* Status.OFF */.qb.OFF ? 0 : 4;
        // Check if we are getting an error because of a missing main sensor.
        var errorMessage;
        if (mainSensorConfigurationError === true) {
            errorMessage = t([
                "line:noMainSensorConfigured"
            ], {
                defaultValue: "No main sensor configured"
            });
        }
        var overdueTaskCount = countOverdueTasks(line);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: conf.oneLineCardEachRow ? 12 : 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    className: classes.card,
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* ImperceptibleLink */.ah, {
                        href: {
                            pathname: "/line",
                            query: {
                                lineId: "".concat(id),
                                tab: "live"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: classes.anchor,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    sx: {
                                        px: 3,
                                        py: 2
                                    },
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                flex: "1 1 auto",
                                                overflow: "hidden"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(constants/* LINE_ICON */.zN, {
                                                            style: {
                                                                color: statusColor
                                                            },
                                                            className: (0,clsx_m["default"])("rtl-margin-left", "".concat(classes.lineIcon, " hideInPercy"))
                                                        }),
                                                        name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    color: "textSecondary",
                                                    variant: "body2",
                                                    noWrap: true,
                                                    children: description
                                                })
                                            ]
                                        }),
                                        overdueTaskCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/maintenance",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                title: t([
                                                    "maintenance:maintenanceRequired"
                                                ], {
                                                    defaultValue: "Maintenance required for one or more components"
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    size: "large",
                                                    sx: {
                                                        mr: 1
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Build/* default */.Z, {
                                                        sx: {
                                                            color: red/* default.700 */.Z[700]
                                                        }
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signal_avatar/* default */.Z, {
                                            conn: {
                                                strength: strength,
                                                type: "wifi"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(line_card_menu, {
                                            lineId: id,
                                            mainSensor: line.mainSensor,
                                            openDialog: this.openDialog
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                    className: "hideInPercy",
                                    style: {
                                        paddingBottom: 0,
                                        padding: !conf.showGraph ? 0 : undefined
                                    },
                                    children: (mainSensor === null || mainSensor === void 0 ? void 0 : (ref10 = mainSensor.config) === null || ref10 === void 0 ? void 0 : ref10.type) !== schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                        compareForUpdate: "".concat(dataHash, "-").concat(conf.showStops, "-").concat(conf.showStopLabels, "-").concat(conf.oneLineCardEachRow),
                                        aggressivelyMinimizeRendering: true,
                                        configOptions: {
                                            disableAxisLabel: mainSensorConfigurationError,
                                            t: t,
                                            language: i18n.language,
                                            height: "180px",
                                            sensor: mainSensor,
                                            theme: theme,
                                            showStops: conf.showStops,
                                            showStopLabels: conf.showStopLabels
                                        },
                                        hideChart: !conf.showGraph,
                                        configFn: overview_config,
                                        loading: chartLoading,
                                        error: mainSensorConfigurationError,
                                        errorMsg: errorMessage
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                        compareForUpdate: "".concat(dataHash, "-").concat(conf.showStops, "-").concat(conf.showStopLabels, "-").concat(conf.oneLineCardEachRow),
                                        aggressivelyMinimizeRendering: true,
                                        configOptions: {
                                            t: t,
                                            chartHeight: "180px",
                                            data: mainSensor,
                                            theme: theme,
                                            disableLabels: !conf.showStopLabels
                                        },
                                        hideChart: !conf.showGraph,
                                        configFn: manual_process_config/* default */.Z,
                                        loading: chartLoading,
                                        error: mainSensorConfigurationError,
                                        errorMsg: errorMessage
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    p: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components, {
                                        lineStatus: {
                                            statusText: statusText,
                                            statusColor: statusColor,
                                            lineDuration: lineDuration
                                        },
                                        line: line,
                                        conf: conf
                                    })
                                })
                            ]
                        })
                    })
                }),
                settingsDialogOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LineSettingsDialog, {
                    lineId: line.id,
                    handleOpenClose: this.handleDialogChange,
                    open: this.state.settingsDialogOpen,
                    refetchQueries: refetchQueries,
                    deleteRefetchQueries: deleteRefetchQueries
                }) : null
            ]
        });
    };
    LineOverviewCard.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var ref, ref1;
        if (nextProps.dataHash !== prevState.dataHash && ((ref = nextProps.conf) === null || ref === void 0 ? void 0 : ref.showGraph) !== false) {
            return {
                dataHash: nextProps.dataHash
            };
        } else if (((ref1 = nextProps.conf) === null || ref1 === void 0 ? void 0 : ref1.showGraph) === false) {
            return {
                dataHash: ""
            };
        }
        return null;
    };
    return LineOverviewCard;
}(react.Component);
var line_card_enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line",
    "device"
]), (0,with_styles/* withStyles */.D)(line_card_styles, {
    withTheme: true
}));
/* harmony default export */ var line_card = (line_card_enhance(LineOverviewCard));

;// CONCATENATED MODULE: ./views/lines/overview-cards.tsx














var checkForMissingMainSensor = function(setMainSensorConfigurationError) {
    return function(error) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        // Check if we are getting an error because of a missing main sensor.
        if ((error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.path) === null || ref2 === void 0 ? void 0 : ref2.length) === 2 && (error === null || error === void 0 ? void 0 : (ref3 = error.graphQLErrors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.path) === null || ref5 === void 0 ? void 0 : ref5[0]) === "line" && (error === null || error === void 0 ? void 0 : (ref6 = error.graphQLErrors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.path) === null || ref8 === void 0 ? void 0 : ref8[1]) === "mainSensor") {
            setMainSensorConfigurationError(true);
        }
    };
};
// We extract the query, so that we can maintain a state for each Apollo query.
var InternalLineCard = function(param) {
    var cardConf = param.cardConf, cachePolicy = param.cachePolicy, lineSimple = param.lineSimple, lineVariables = param.lineVariables;
    var ref = (0,react.useState)(""), dataHash = ref[0], setDataHash = ref[1];
    var ref1 = (0,react.useState)(false), mainSensorConfigurationError = ref1[0], setMainSensorConfigurationError = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
        ssr: false,
        partialRefetch: true,
        fetchPolicy: cachePolicy,
        // FIXME: Batching currently screws up Line Status.
        // context={{ batchFour: true }}
        skip: mainSensorConfigurationError,
        errorPolicy: "all" // Necessary for returning partial data.
        ,
        query: (line_overview_with_kpi_default()),
        onCompleted: (0,hash/* updateDataHash */.G)(setDataHash),
        onError: checkForMissingMainSensor(setMainSensorConfigurationError),
        variables: lineVariables,
        children: function(param) {
            var data = param.data, loading = param.loading;
            var ref;
            var line = (ref = data === null || data === void 0 ? void 0 : data.line) !== null && ref !== void 0 ? ref : lineSimple;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(line_card, {
                line: line,
                loading: loading,
                mainSensorConfigurationError: mainSensorConfigurationError,
                dataHash: dataHash,
                refetchQueries: [
                    {
                        query: (line_overview_with_kpi_default()),
                        variables: lineVariables
                    }
                ],
                deleteRefetchQueries: [
                    {
                        query: (lines_list_simple_default()),
                        variables: {}
                    }
                ],
                conf: cardConf
            }, line.id);
        }
    });
};
var LineCards = /*#__PURE__*/ react.memo(function(param) {
    var filteredLines = param.filteredLines, currentPage = param.currentPage, pageSize = param.pageSize, timeAtLoad = param.timeAtLoad, cardConf = param.cardConf, cachePolicy = param.cachePolicy;
    var hasModuleAccess = (0,use_iam/* useIAM */.e)().hasModuleAccess;
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useLocalStorage */._)([
        constants/* LOCAL_STORAGE_PINNED */.dV,
        "LINES"
    ].join("_"), []), 1), pinnedLines = ref[0];
    var mostRecentMinute = Math.round(timeAtLoad.getTime() / 1..minutes) * 1..minutes;
    var currentPageLines = (0,_to_consumable_array/* default */.Z)(filteredLines).sort(function(l) {
        return pinnedLines.includes(l.id) ? -1 : 1;
    }).slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    var ref1;
    var timeInterval = (ref1 = cardConf === null || cardConf === void 0 ? void 0 : cardConf.timeInterval) !== null && ref1 !== void 0 ? ref1 : 8;
    if (!(currentPageLines === null || currentPageLines === void 0 ? void 0 : currentPageLines.length)) {
        return null;
    }
    var now = new Date(mostRecentMinute);
    var validIn = (0,schedule/* getYearWeek */.dl)(now);
    var weekDayNum = (now.getDay() || 7) - 1;
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: currentPageLines.map(function(lineSimple) {
            var lineVariables = {
                lineId: lineSimple.id,
                time: [
                    types/* toISOString */.Y6({
                        from: new Date(mostRecentMinute - timeInterval.hours),
                        to: now
                    }), 
                ],
                points: constants/* SAMPLE_POINTS */.fd,
                showStops: cardConf.showStops === true || cardConf.countUnregisteredStops === true ? true : false,
                showOee: cardConf.showOee,
                showWeeklyProgress: !!cardConf.showWeeklyProgress,
                showDailyProgress: !!cardConf.showDailyProgress,
                hasMaintenanceModule: hasModuleAccess(auth_types/* Module.Maintenance */.Y.Maintenance),
                validIn: validIn,
                pastWeek: [
                    types/* toISOString */.Y6({
                        to: now,
                        from: new Date(new Date(mostRecentMinute - weekDayNum * 1..days).setHours(0, 0, 0))
                    }), 
                ],
                pastDay: [
                    types/* toISOString */.Y6({
                        to: now,
                        from: new Date(new Date(mostRecentMinute - 1..days).setHours(0, 0, 0))
                    }), 
                ]
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLineCard, {
                lineSimple: lineSimple,
                lineVariables: lineVariables,
                cardConf: cardConf,
                cachePolicy: cachePolicy
            }, "lineSimple:".concat(lineSimple.id));
        })
    }));
}, function(prevProps, nextProps) {
    var ref, ref1;
    if (((ref = prevProps.filteredLines) === null || ref === void 0 ? void 0 : ref.length) !== ((ref1 = nextProps.filteredLines) === null || ref1 === void 0 ? void 0 : ref1.length) || prevProps.currentPage !== nextProps.currentPage || prevProps.pageSize !== nextProps.pageSize || prevProps.cardConf !== nextProps.cardConf || prevProps.cardConf && nextProps.cardConf && prevProps.cardConf.timeInterval !== nextProps.cardConf.timeInterval || prevProps.timeAtLoad !== nextProps.timeAtLoad) {
        return false;
    }
    return true;
});
/* harmony default export */ var overview_cards = (LineCards);

// EXTERNAL MODULE: ./components/bars/overview-top-bar.tsx + 1 modules
var overview_top_bar = __webpack_require__(19536);
;// CONCATENATED MODULE: ./views/lines/overview-top-bar.tsx




var LinesTopBar = function(param) {
    var search = param.search, page = param.page, filteredLines = param.filteredLines, pageSize = param.pageSize, cardConf = param.cardConf, handlePageChange = param.handlePageChange, handleSearchChange = param.handleSearchChange, updateConf = param.updateConf, updateIntervalConf = param.updateIntervalConf, updateRefreshIntervalConf = param.updateRefreshIntervalConf, updateInterval = param.updateInterval, nextLiveUpdate = param.nextLiveUpdate;
    var suggestions = (0,react.useMemo)(function() {
        return filteredLines.filter(function(line) {
            if (!search.length) {
                return true;
            }
            if (!(line === null || line === void 0 ? void 0 : line.name)) {
                return false;
            }
            return search.some(function(searchTerm) {
                return [
                    line.name.toLowerCase(),
                    (line.description || "").toLowerCase()
                ].some(function(entry) {
                    var ref;
                    return (searchTerm === null || searchTerm === void 0 ? void 0 : (ref = searchTerm.value) === null || ref === void 0 ? void 0 : ref.value) && entry.includes(searchTerm.value.value);
                });
            });
        }).map(function(line) {
            var label = line.name || line.description;
            return {
                label: label,
                value: {
                    type: "string",
                    value: label.toLowerCase()
                }
            };
        });
    }, [
        filteredLines,
        search
    ]);
    var totalCount = filteredLines.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_top_bar/* default */.Z, {
        search: search,
        suggestions: suggestions,
        page: page,
        pageSize: pageSize,
        totalCount: totalCount,
        handlePageChange: handlePageChange,
        handleSearchChange: handleSearchChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
            cardConf: cardConf,
            updateConf: updateConf,
            updateIntervalConf: updateIntervalConf,
            updateInterval: updateInterval,
            updateRefreshIntervalConf: updateRefreshIntervalConf,
            nextLiveUpdate: nextLiveUpdate
        })
    });
};
/* harmony default export */ var lines_overview_top_bar = (LinesTopBar);

;// CONCATENATED MODULE: ./views/lines/overview-page.tsx































var overview_page_styles = function(theme) {
    return {
        button: {
            position: "absolute",
            bottom: theme.spacing(3),
            right: theme.spacing(3)
        },
        message: {
            paddingBottom: theme.spacing(2)
        },
        lightBtn: {
            color: "#fff"
        }
    };
};
/**
 * Only accept valid cache policies.
 */ function isCachePolicy(val) {
    var allowed = [
        "cache-first",
        "network-only",
        "cache-only",
        "no-cache",
        "standby",
        "cache-and-network", 
    ];
    return allowed.includes(val);
}
var LineCardPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LineCardPage, _Component);
    var _super = (0,_create_super/* default */.Z)(LineCardPage);
    function LineCardPage(props) {
        (0,_class_call_check/* default */.Z)(this, LineCardPage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            search: [],
            page: 0,
            createModalOpen: false,
            device: "",
            cardConf: defaultCardConf,
            kpiOptions: [],
            cachePolicy: "no-cache"
        };
        _this.pageSize = constants/* PAGE_SIZE */.IV;
        _this.filterLines = function(lines) {
            var filteredLines = lines.filter(function(line) {
                var ref;
                // If we haven't started searching yet, include all results.
                if (!((ref = _this.state.search) === null || ref === void 0 ? void 0 : ref.length)) {
                    return true;
                }
                // Filter out both results and remaining suggestions, based on the search filter.
                var foundInSearch = true;
                _this.state.search.every(function(searchTerm) {
                    if (searchTerm && searchTerm.value && searchTerm.value.value) {
                        var ref, ref1;
                        foundInSearch = ((ref = line === null || line === void 0 ? void 0 : line.name) !== null && ref !== void 0 ? ref : "").toLowerCase().includes(searchTerm.value.value.toLowerCase()) || ((ref1 = line === null || line === void 0 ? void 0 : line.description) !== null && ref1 !== void 0 ? ref1 : "").toLowerCase().includes(searchTerm.value.value.toLowerCase());
                    }
                    return Boolean(foundInSearch);
                });
                return foundInSearch;
            });
            // Sort the lines alphabetically, to always give a consistent view to the user.
            return filteredLines.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        };
        _this.getWrappedMessage = function() {
            return(// TODO: Only show this if you also have any devices. Else we should tell them to contact their local
            // administrator, like we do in devices.
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(constants/* LINE_ICON */.zN, {
                        style: {
                            height: "100px",
                            width: "100px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: _this.props.classes.message,
                        children: _this.props.t([
                            "line:noLinesYet"
                        ], {
                            defaultValue: "You haven't created any lines yet!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        onClick: _this.handleModalOpenClose(true),
                        className: _this.props.classes.lightBtn,
                        "aria-label": _this.props.t([
                            "shared:getStarted"
                        ], {
                            defaultValue: "Get started"
                        }),
                        children: _this.props.t([
                            "shared:getStarted"
                        ], {
                            defaultValue: "Get started"
                        })
                    })
                ]
            }));
        };
        _this.updateSessionStorage = function(newRoute) {
            // Update the session (tab specific) storage entry for navigation.
            if (typeof Storage !== "undefined") {
                window.sessionStorage.setItem(constants/* SESSION_STORAGE_LINES_NAVIGATION_OVERVIEW_SEARCH_STATE_KEY */.fs, JSON.stringify({
                    route: {
                        pathname: newRoute.pathname,
                        query: newRoute.query
                    }
                }));
            }
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePageChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this1.props.router, pathname = _router.pathname, query = _router.query;
                            _this1.setState({
                                page: page
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                page: page
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this1.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleSearchChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this2.props.router, pathname = _router.pathname, query = _router.query;
                            _this2.setState({
                                search: val,
                                page: 0
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                search: JSON.stringify(val),
                                page: 0
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this2.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleModalOpenClose = function(open) {
            return function() {
                return _this.setState({
                    createModalOpen: open
                });
            };
        };
        _this.updateConf = function(key, check) {
            _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), (0,_define_property/* default */.Z)({}, key, check))
            }, function() {
                var ref;
                // Labels can only ever be shown when stops are also enabled, so we force `showStops` to be enabled if it isn't already.
                if (key === "showStopLabels" && check && ((ref = _this.state.cardConf) === null || ref === void 0 ? void 0 : ref.showStops) === false) {
                    _this.setState({
                        cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                            showStops: true
                        })
                    });
                }
            });
        };
        _this.updateIntervalConf = function(interval) {
            return _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                    timeInterval: interval
                })
            });
        };
        _this.updateRefreshIntervalConf = function(newInterval) {
            _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                    refreshInterval: newInterval
                })
            });
            _this.props.changeUpdateInterval(newInterval);
        };
        try {
            var ref, ref1;
            if (typeof Storage !== "undefined") {
                try {
                    var layoutConfiguration = JSON.parse(window.localStorage.getItem(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ));
                    if (instanceOfCardConf(layoutConfiguration)) {
                        _this.state.cardConf = (0,_object_spread/* default */.Z)({}, _this.state.cardConf, layoutConfiguration);
                    }
                // tslint:disable-next-line:no-empty
                } catch (_) {}
            }
            if (props.router.query.search) {
                try {
                    var searchQuery = Array.isArray(props.router.query.search) ? props.router.query.search[0] : props.router.query.search;
                    _this.state.search = JSON.parse(searchQuery);
                } catch (routerError) {
                    console.error(routerError);
                }
            }
            // NOTE: We allow setting the cache policy via the URL to allow us to
            // quickly test out different caching strategies.
            if (props.router.query.cachePolicy) {
                try {
                    var cachePolicyQuery = Array.isArray(props.router.query.cachePolicy) ? props.router.query.cachePolicy[0] : props.router.query.cachePolicy;
                    if (isCachePolicy(cachePolicyQuery)) {
                        _this.state.cachePolicy = cachePolicyQuery;
                    }
                } catch (routerError1) {
                    console.error(routerError1);
                }
            }
            if (props.router.query.page) {
                try {
                    var pageQuery = Array.isArray(props.router.query.page) ? props.router.query.page[0] : props.router.query.page;
                    _this.state.page = parseInt(pageQuery, 10);
                } catch (routerError2) {
                    console.error(routerError2);
                }
            }
            if (props.router.query.action) {
                try {
                    var actionQuery = Array.isArray(props.router.query.action) ? props.router.query.action[0] : props.router.query.action;
                    _this.state.createModalOpen = actionQuery === "create";
                    delete props.router.query.action;
                } catch (routerError3) {
                    console.error(routerError3);
                }
            }
            if (props.router.query.device) {
                try {
                    var deviceQuery = Array.isArray(props.router.query.device) ? props.router.query.device[0] : props.router.query.device;
                    _this.state.device = String(deviceQuery);
                    delete props.router.query.device;
                } catch (routerError4) {
                    console.error(routerError4);
                }
            }
            var updatedQuery = (0,_object_spread/* default */.Z)({}, props.router.query);
            var url = (0,native_url.format)({
                pathname: props.router.pathname,
                query: updatedQuery
            });
            void router_default().replace(url, url, {
                shallow: true
            });
            var ref2, ref3;
            _this.updateSessionStorage({
                pathname: (ref2 = props === null || props === void 0 ? void 0 : (ref = props.router) === null || ref === void 0 ? void 0 : ref.pathname) !== null && ref2 !== void 0 ? ref2 : "/lines",
                query: (ref3 = props === null || props === void 0 ? void 0 : (ref1 = props.router) === null || ref1 === void 0 ? void 0 : ref1.query) !== null && ref3 !== void 0 ? ref3 : {}
            });
        } catch (error) {
            console.warn("\xbb Something failed in overview-page constructor, hmm...");
        }
        return _this;
    }
    var _proto = LineCardPage.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var ref, ref1, ref2, ref3;
        if (nextProps.timeAtLoad !== this.props.timeAtLoad) {
            return true;
        } else if (((ref = nextState.search) === null || ref === void 0 ? void 0 : ref.length) !== ((ref1 = this.state.search) === null || ref1 === void 0 ? void 0 : ref1.length) || nextState.page !== this.state.page || nextState.createModalOpen !== this.state.createModalOpen || nextState.cardConf !== this.state.cardConf || ((ref2 = nextState.kpiOptions) === null || ref2 === void 0 ? void 0 : ref2.length) !== ((ref3 = this.state.kpiOptions) === null || ref3 === void 0 ? void 0 : ref3.length) || !Object.keys(this.props.features.group).length && Object.keys(nextProps.features.group)) {
            return true;
        }
        return false;
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, classes = _props.classes, t = _props.t, hasFeatureInAnyGroup = _props.hasFeatureInAnyGroup, width = _props.width, timeAtLoad = _props.timeAtLoad, updateInterval = _props.updateInterval;
        var createLineFeature = hasFeatureInAnyGroup([
            "Lines.Line"
        ], "M");
        var nextLiveUpdate = null;
        if (timeAtLoad && updateInterval) {
            nextLiveUpdate = new Date(timeAtLoad.getTime() + updateInterval);
        } else if (updateInterval === null) {
            nextLiveUpdate = null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
            ssr: false,
            partialRefetch: true,
            query: (lines_list_simple_default()),
            fetchPolicy: "cache-and-network",
            errorPolicy: "all" // Necessary for returning partial data.
            ,
            children: function(param) {
                var loading = param.loading, error = param.error, data = param.data;
                var ref;
                var lines = (ref = data === null || data === void 0 ? void 0 : data.lines) !== null && ref !== void 0 ? ref : [];
                var wrappedMessage = !loading && !error && !(lines === null || lines === void 0 ? void 0 : lines.length) ? _this.getWrappedMessage() : undefined;
                // We only short-circuit the render if the query is loading or returned only an error (i.e. not an error + data).
                if (loading && !data || error && !data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lines_overview_top_bar, {
                                search: _this.state.search,
                                filteredLines: [],
                                page: _this.state.page,
                                pageSize: _this.pageSize,
                                handlePageChange: _this.handlePageChange,
                                handleSearchChange: _this.handleSearchChange,
                                cardConf: _this.state.cardConf,
                                updateConf: _this.updateConf,
                                updateIntervalConf: _this.updateIntervalConf,
                                updateRefreshIntervalConf: _this.updateRefreshIntervalConf,
                                updateInterval: updateInterval,
                                nextLiveUpdate: nextLiveUpdate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                                loading: loading,
                                error: error,
                                wrappedMessage: wrappedMessage
                            })
                        ]
                    });
                }
                var filteredLines = _this.filterLines(lines);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lines_overview_top_bar, {
                            search: _this.state.search,
                            filteredLines: filteredLines,
                            page: _this.state.page,
                            pageSize: _this.pageSize,
                            handlePageChange: _this.handlePageChange,
                            handleSearchChange: _this.handleSearchChange,
                            cardConf: _this.state.cardConf,
                            updateConf: _this.updateConf,
                            updateIntervalConf: _this.updateIntervalConf,
                            updateRefreshIntervalConf: _this.updateRefreshIntervalConf,
                            updateInterval: updateInterval,
                            nextLiveUpdate: nextLiveUpdate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: loading,
                            error: error,
                            data: data,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 1,
                                alignItems: "stretch",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_cards, {
                                        filteredLines: filteredLines,
                                        currentPage: _this.state.page,
                                        pageSize: _this.pageSize,
                                        timeAtLoad: timeAtLoad,
                                        cardConf: _this.state.cardConf,
                                        cachePolicy: _this.state.cachePolicy
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        container: true,
                                        xs: 12,
                                        direction: "row-reverse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                                mdUp: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                                        totalPages: Math.ceil(filteredLines.length / _this.pageSize),
                                                        currentPage: _this.state.page,
                                                        onCurrentPageChange: _this.handlePageChange,
                                                        totalCount: filteredLines.length,
                                                        pageSize: _this.pageSize
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateLineDialog, {
                            open: _this.state.createModalOpen,
                            handleOpenClose: _this.handleModalOpenClose(!_this.state.createModalOpen)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_fab/* default */.Z, {
                            title: createLineFeature ? t([
                                "line:createNewLine"
                            ], {
                                defaultValue: "Create new line"
                            }) : t([
                                "line:noPermissionToCreateLine"
                            ], {
                                defaultValue: "You don't have permission to create a new line"
                            }),
                            disabled: !createLineFeature,
                            onClick: _this.handleModalOpenClose(true)
                        })
                    ]
                });
            }
        });
    };
    return LineCardPage;
}(react.Component);
var overview_page_enhance = (0,Recompose_esm/* compose */.qC)(with_line/* withLine */.X, with_iam/* withIAM */.$, router.withRouter, (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(overview_page_styles), (0,with_width/* withWidth */.of)());
/* harmony default export */ var overview_page = (overview_page_enhance(LineCardPage));

;// CONCATENATED MODULE: ./pages/lines/index.tsx









var Lines = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useLocalStorage */._)(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ, defaultCardConf), 2), cardConf = ref[0], setCardConf = ref[1];
    var ref1 = (0,react.useState)(new Date()), timeAtLoad = ref1[0], setTimeAtLoad = ref1[1];
    var changeUpdateInterval = (0,react.useCallback)(function(interval) {
        setCardConf((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardConf), {
            refreshInterval: interval
        }));
    }, [
        cardConf
    ]);
    (0,react.useEffect)(function() {
        if (!cardConf.refreshInterval) {
            return;
        }
        var handle = setTimeout(function() {
            setTimeAtLoad(new Date());
        }, cardConf.refreshInterval);
        return function() {
            return clearTimeout(handle);
        };
    }, [
        timeAtLoad,
        cardConf.refreshInterval
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_page, {
        timeAtLoad: timeAtLoad,
        updateInterval: cardConf.refreshInterval,
        changeUpdateInterval: changeUpdateInterval
    });
};
var __N_SSG = true;
/* harmony default export */ var lines = (Lines);


/***/ }),

/***/ 24877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y6": function() { return /* binding */ toISOString; }
/* harmony export */ });

// NOTE: This preserves the "optionality" of the input fields, e.g. from and to,
// but maps the rhs type to string.
function toISOString(time) {
    var mappedRange = {};
    if (time.from) {
        mappedRange.from = time.from.toISOString();
    }
    if (time.to) {
        mappedRange.to = time.to.toISOString();
    }
    return mappedRange;
}


/***/ }),

/***/ 70912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oee_kpi_card; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/svg-gauge@1.0.7/node_modules/svg-gauge/index.js
var svg_gauge = __webpack_require__(39428);
var svg_gauge_default = /*#__PURE__*/__webpack_require__.n(svg_gauge);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./views/tabs/oee/oee-target-value.tsx


var SVG_NS = "http://www.w3.org/2000/svg";
var OEETargetValue = function(props) {
    var _dialRadius = props.dialRadius, dialRadius = _dialRadius === void 0 ? 40 : _dialRadius, _dialStartAngle = props.dialStartAngle, dialStartAngle = _dialStartAngle === void 0 ? 135 : _dialStartAngle, _dialEndAngle = props.dialEndAngle, dialEndAngle = _dialEndAngle === void 0 ? 45 : _dialEndAngle, _gaugeCenterX = props.gaugeCenterX, gaugeCenterX = _gaugeCenterX === void 0 ? 50 : _gaugeCenterX, _gaugeCenterY = props.gaugeCenterY, gaugeCenterY = _gaugeCenterY === void 0 ? 50 : _gaugeCenterY, targetValue = props.targetValue, gaugeClass = props.gaugeClass;
    var validatedTargetValue = validateTargetValue(targetValue);
    var startValue = validatedTargetValue - 0.5;
    var startAngle = getAngle(startValue, 360 - Math.abs(dialStartAngle - dialEndAngle));
    var endAngle = getAngle(validatedTargetValue, 360 - Math.abs(dialStartAngle - dialEndAngle));
    var coords = getDialCoords(gaugeCenterX, gaugeCenterY, dialRadius, startAngle + dialStartAngle, endAngle + dialStartAngle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        height: "100%",
        width: "100%",
        xmlns: SVG_NS,
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        className: gaugeClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "#666",
                strokeWidth: 8,
                x1: coords.start.x,
                y1: coords.start.y,
                x2: coords.end.x,
                y2: coords.end.y
            }),
            getSVGText(validatedTargetValue)
        ]
    });
};
/* harmony default export */ var oee_target_value = (OEETargetValue);
var getSVGText = function(targetValue) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
        fill: "grey",
        textAnchor: "middle",
        fontSize: "40%",
        fontFamily: "sans-serif",
        x: "50",
        y: "63",
        children: [
            "Target: ",
            targetValue.toFixed(1),
            "%"
        ]
    });
};
var validateTargetValue = function(targetValue) {
    return Math.max(Math.min(targetValue, 100), 0);
};
/**
 * Gets cartesian co-ordinates for a specified radius and angle (in degrees)
 * @param cx {Number} The center x co-oriinate
 * @param cy {Number} The center y co-ordinate
 * @param radius {Number} The radius of the circle
 * @param angle {Number} The angle in degrees
 * @return An object with x,y co-ordinates
 */ var getCartesian = function(cx, cy, radius, angle) {
    var rad = angle * Math.PI / 180;
    return {
        x: Math.round((cx + radius * Math.cos(rad)) * 1000) / 1000,
        y: Math.round((cy + radius * Math.sin(rad)) * 1000) / 1000
    };
};
// Returns start and end points for dial
// i.e. starts at 135deg ends at 45deg with large arc flag
// REMEMBER!! angle=0 starts on X axis and then increases clockwise
var getDialCoords = function(cx, cy, radius, startAngle, endAngle) {
    return {
        end: getCartesian(cx, cy, radius, endAngle),
        start: getCartesian(cx, cy, radius, startAngle)
    };
};
/**
 * Translates percentage value to angle. e.g. If gauge span angle is 180deg, then 50%
 * will be 90deg
 */ var getAngle = function(percentage, gaugeSpanAngle) {
    return percentage * gaugeSpanAngle / 100;
};

;// CONCATENATED MODULE: ./views/tabs/oee/oee-kpi-card.tsx
















var styles = function(theme) {
    return {
        card: {
            width: "100%",
            minHeight: "150px"
        },
        cardHover: {
            transition: "box-shadow .25s",
            "&:hover": {
                cursor: "pointer",
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        headingContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "30px"
        },
        title: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            position: "absolute"
        },
        valueContainer: {
            display: "flex"
        },
        gaugeWrapper: {
            zIndex: 1,
            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center"
        },
        customTargetWrapper: {
            zIndex: 2,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            overflow: "inherit"
        },
        gaugeContainer: {
            width: "100%",
            maxWidth: "300px",
            display: "block"
        },
        gaugeContainerSmall: {
            width: "100%",
            maxWidth: "45px",
            maxHeight: "70px",
            display: "block"
        },
        gaugeValue: {
            strokeWidth: "6"
        },
        gaugeDial: {
            stroke: "#efefef",
            strokeWidth: "6"
        },
        gaugeText: {
            fill: theme.palette.text.primary,
            fontFamily: "sans-serif",
            fontWeight: "bold",
            fontSize: "0.9em"
        },
        gaugeTextSmall: {
            fill: theme.palette.text.primary,
            fontFamily: "sans-serif",
            fontWeight: "bold",
            fontSize: "1.8em"
        }
    };
};
var OEEKPICard = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(OEEKPICard, _Component);
    var _super = (0,_create_super/* default */.Z)(OEEKPICard);
    function OEEKPICard() {
        (0,_class_call_check/* default */.Z)(this, OEEKPICard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.gauge = null;
        _this.gaugeEl = null;
        _this.defaultOptions = {
            animDuration: 1,
            showValue: true,
            max: 100,
            min: 0,
            color: function() {
                return _this.props.gaugeColor;
            },
            gaugeClass: _this.props.classes.gaugeContainer,
            dialClass: _this.props.classes.gaugeDial,
            valueDialClass: _this.props.classes.gaugeValue,
            valueClass: _this.props.classes.gaugeText,
            gaugeTargetValueClass: "gaugeTargetValue",
            label: function(value) {
                if (typeof value !== "number") {
                    return "&infin; %";
                }
                return "".concat(value.toFixed(1), " %");
            }
        };
        return _this;
    }
    var _proto = OEEKPICard.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.renderGauge(this.props);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _) {
        var value = this.props.value;
        if (value !== nextProps.value) {
            this.renderGauge(nextProps);
            return true;
        }
        return true;
    };
    _proto.renderGauge = function renderGauge(props) {
        var gaugeOptions = Object.assign({}, this.defaultOptions, props);
        if (props.size === "small") {
            gaugeOptions.valueClass = props.classes.gaugeTextSmall;
            gaugeOptions.label = function(value) {
                if (typeof value !== "number") {
                    return "&infin;";
                }
                return "".concat(value.toFixed(1));
            };
        }
        if (this.gaugeEl) {
            this.gauge = this.gauge || svg_gauge_default()(this.gaugeEl, gaugeOptions);
            this.gauge.setValueAnimated(props.value, gaugeOptions.animDuration);
        }
    };
    _proto.render = function render() {
        var size = this.props.size;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: size === "small" ? 3 : 12,
            sm: 3,
            md: 3,
            lg: 3,
            children: size === "small" ? this.renderOeeSmall() : this.renderOeeWithCard()
        });
    };
    _proto.renderOeeWithCard = function renderOeeWithCard() {
        var _this = this;
        var _props = this.props, classes = _props.classes, title = _props.title, onClick = _props.onClick, targetValue = _props.targetValue, additionalInfo = _props.additionalInfo;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: onClick ? onClick : undefined,
            className: (0,clsx_m["default"])(classes.card, onClick && classes.cardHover),
            elevation: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        placement: "top",
                        title: additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.headingContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                align: "center",
                                variant: "body1",
                                className: classes.title,
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.gaugeWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.valueContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.gaugeContainer,
                                    ref: function(el) {
                                        return _this.gaugeEl = el;
                                    }
                                })
                            }),
                            targetValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.customTargetWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_target_value, {
                                    targetValue: targetValue
                                })
                            }) : null
                        ]
                    })
                ]
            })
        });
    };
    _proto.renderOeeSmall = function renderOeeSmall() {
        var _this = this;
        var _props = this.props, classes = _props.classes, title = _props.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.valueContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.gaugeContainerSmall,
                ref: function(el) {
                    return _this.gaugeEl = el;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    children: title
                })
            })
        });
    };
    return OEEKPICard;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,with_styles/* withStyles */.D)(styles));
/* harmony default export */ var oee_kpi_card = (enhance(OEEKPICard));


/***/ })

}]);